import React, { Component, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Modal from '../components/modal.jsx'
import {SlideshowLightbox, initLightboxJS} from 'lightbox.js-react'
import CacheBuster from 'react-cache-buster';
import Admin from './admin.jsx'
import Schueler from './schueler.jsx';
import {stringToHML} from './generalfunctions.jsx'
import Unterrichtsanfrage from './unterrichtsanfrage.jsx';
import Akkord from './akkord.jsx';
import Produkte from './produkte.jsx';
import Lernvideos from './lernvideos.jsx'
import YoutubeVideo from './youtubevideo.jsx'
import PayPal from './paypal.jsx';
import ApplePayButton from './applepaybutton.jsx'
import { Link, Route, Routes, useNavigate } from 'react-router-dom';



class Hauptseite extends Component{

    constructor(props){

        super(props)
        this.state=(
            {              
                activeUser: null,
                language:'de',
                activePage:'home',
                builddate:'',
                server:null,
                isLoggedIn:false,
                isAdmin:0,
                strings:[],
                loginname:'',
                errortext:'',
                email:'',
                passwort:'',
                password1:'',
                password2:'',
                benutzername:'',
                forgotemail:'',
                registeremail:'',
                registername:'',
                sentEmail: false,
                repertoire:[],
                anfrage_name:'',
                anfrage_email:'',
                anfrage_telefon:'',
                anfrage_text:'',
                passwortvergessen:false,
                registrieren:false,
                schuelerFilter:'aktiv',
                schueler:[],
                filteredSchueler:[],
                activeSchueler: null,
                activeAbo: null,
                adminPage:1,
                schuelerPage:1,
                gespeichert:'',
                nav_abo_modus:1,
                kursthemen:[],
                unterrichtsorte:[],
                lektionenpreise:null,
                lektionen:[],
                slideShowOpen:false,
                activeLektion:null,
                schueler_lektionen:[],
                schueler_taeglicheLektion:{
                    id:0,
                    abo_id:0,
                    unterrichtszeit:'',
                    lfdnr:0,
                    bezahlt:0,
                    ist_abgeschlossen:0,
                    thema:'',
                    beschreibung_de:'',
                    stilrichtung:'',
                    ist_oeffentlich:0,
                    preis:0,
                    cover_image:'',
                    videourl:'',
                    video_ab_sec:0,
                    video_dauer:0,
                    standardcover:0,
                    ist_technische_uebung:0,
                    suchbegriffe:'',
                    unterrichtseinheiten:[]

                },
                schuelerAbos:[],
                activeSchuelerAbo: null,
                angebotSchuelerAbo: null,
                zahlungsBedingungenGelesen:false,
                file1:null,
                file2:null,
                file3:null,
                pdfs: [],
                aktiveAbos:[],
                akkorde:[],
                benutzer_akkorde:[],
                akkord:{
                    id:0,
                    name_de:'',
                    name_en:'',
                    bund_saite1:'',
                    bund_saite2:'',
                    bund_saite3:'',
                    bund_saite4:'',
                    bund_saite5:'',
                    bund_saite6:'',
                    finger_saite1:'',
                    finger_saite2:'',
                    finger_saite3:'',
                    finger_saite4:'',
                    finger_saite5:'',
                    finger_saite6:'',
                    barree:0,
                    lage:1,
                    ist_oeffentlich:1
                },
                unterrichtseinheit:{
                    id:0,
                    lektion_id:0,
                    thema:'neues Thema',
                    bemerkungen:'',
                    videourl:'',
                    pdf_id:0,
                    rangfolge:0,
                    ist_oeffentlich:0,
                    stilrichtung:'',
                    lernziele:'',
                    video_ab_sec:0,
                    video_dauer:0
                },
                ueEditMode:0,
                produkt_lektionen:[],
                filtered_produkt_lektionen:[],
                suchenText:'',
                activeProduct: null,
                youtubeVideo:null,
                activeUnterrichtseinheit:null,
                einkaufswagen:[],
                lastActivePage:'',
                unterrichtgeklickt:0,
                einkauf_schritt:0,
                kaeufer_passwort:'',
                alleBenutzerRegistriert:[],
                infoTextPasswortWurdeGesendet:''
            }
        )
       
        this.modalImpressum = this.modalImpressum.bind(this)
        this.modalDatenschutz = this.modalDatenschutz.bind(this)
        this.modalLogindialog = this.modalLogindialog.bind(this)
        this.modalError = this.modalError.bind(this)    
        this.anmeldeMenu = this.anmeldeMenu.bind(this)
        this.navBar = this.navBar.bind(this)
        this.getStrings = this.getStrings.bind(this)
        this.getLanguageString = this.getLanguageString.bind(this)
        this.getContent = this.getContent.bind(this)
        this.homeContent = this.homeContent.bind(this)
        this.aboutContent = this.aboutContent.bind(this)
        this.gitarrenschuleContent = this.gitarrenschuleContent.bind(this)
        this.loginContent=this.loginContent.bind(this)
        this.checkLogin = this.checkLogin.bind(this)
        this.eingeloggtContent = this.eingeloggtContent.bind(this)
        this.accountContent = this.accountContent.bind(this)
        this.passwortvergessenContent = this.passwortvergessenContent.bind(this)
        this.sendNewPassword = this.sendNewPassword.bind(this)
        this.neuesPasswortSpeichern = this.neuesPasswortSpeichern.bind(this)
        this.musicContent = this.musicContent.bind(this)
        this.contactContent = this.contactContent.bind(this)
        this.sendeAnfrage = this.sendeAnfrage.bind(this)
        this.neuerSchueler = this.neuerSchueler.bind(this)
        this.getSchueler = this.getSchueler.bind(this)
        this.setSchuelerFilter=this.setSchuelerFilter.bind(this)
        this.changeSchuelerData = this.changeSchuelerData.bind(this)
        this.saveSchueler = this.saveSchueler.bind(this)
        this.changeSchuelerStatus = this.changeSchuelerStatus.bind(this)
        this.deleteSchuelerDialog = this.deleteSchuelerDialog.bind(this)
        this.schuelerLoeschen = this.schuelerLoeschen.bind(this)
        this.setKursthemaid = this.setKursthemaid.bind(this)
        this.setUnterrichtsort = this.setUnterrichtsort.bind(this)
        this.setAltersgruppe = this.setAltersgruppe.bind(this)
        this.setLektionsdauer = this.setLektionsdauer.bind(this)
        this.changeAbo=this.changeAbo.bind(this)
        this.setAboStatus = this.setAboStatus.bind(this)
        this.saveAbo = this.saveAbo.bind(this)
        this.setAbo = this.setAbo.bind(this)
        this.deleteAboDialog = this.deleteAboDialog.bind(this)
        this.aboLoeschen = this.aboLoeschen.bind(this)
        this.neuesAbo = this.neuesAbo.bind(this)
        this.getLektionen = this.getLektionen.bind(this) 
        this.saveUnterrichtseinheit=this.saveUnterrichtseinheit.bind(this)
        this.editLektion = this.editLektion.bind(this)
        this.modalEditLektion = this.modalEditLektion.bind(this)
        this.lektionSpeichern = this.lektionSpeichern.bind(this)
        this.modalActiveSchuelerAboDialog = this.modalActiveSchuelerAboDialog.bind(this)
        this.unterrichtsMenu = this.unterrichtsMenu.bind(this)
        this.setAnzahlstunden = this.setAnzahlstunden.bind(this)
        this.neueUnterrichtsanfrage = this.neueUnterrichtsanfrage.bind(this)
        this.toggleNav = this.toggleNav.bind(this)
        this.sendeUnterrichtsanfrage = this.sendeUnterrichtsanfrage.bind(this)
        this.modalUnterrichtsAnfrageFertig = this.modalUnterrichtsAnfrageFertig.bind(this)
        this.aboangebotsenden = this.aboangebotsenden.bind(this)
        this.modalMessageBoxDialog = this.modalMessageBoxDialog.bind(this)
        this.modalAngebotSchuelerAboDialog = this.modalAngebotSchuelerAboDialog.bind(this)
        this.checkUnterrichtsAnfrageAnnehmen = this.checkUnterrichtsAnfrageAnnehmen.bind(this)
        this.fileUpload = this.fileUpload.bind(this)
        this.getPdfs = this.getPdfs.bind(this)
        this.akkordeContent = this.akkordeContent.bind(this)
        this.getAkkorde = this.getAkkorde.bind(this)
        this.sortiereBenutzerAkkorde = this.sortiereBenutzerAkkorde.bind(this)
        this.changeAkkordeIds = this.changeAkkordeIds.bind(this)
        this.isUserChord = this.isUserChord.bind(this)
        this.getBenutzerAkkorde = this.getBenutzerAkkorde.bind(this)
        this.modalNeuerAkkordDialog = this. modalNeuerAkkordDialog.bind(this)
        this.modalNeuesProduktDialog = this.modalNeuesProduktDialog.bind(this)
        this.neuesProdukt = this.neuesProdukt.bind(this)
        this.neuerAkkord = this.neuerAkkord.bind(this)
        this.addTaeglicheUebung = this.addTaeglicheUebung.bind(this)
        this.addTaeglicheUebungAusListe = this.addTaeglicheUebungAusListe.bind(this)
        this.modalNeueUnterrichtseinheit = this.modalNeueUnterrichtseinheit.bind(this)
        this.editUnterrichtseinheit = this.editUnterrichtseinheit.bind(this)
        this.moveUnterrichtseinheit = this.moveUnterrichtseinheit.bind(this)
        this.getTaeglicheLektion = this.getTaeglicheLektion.bind(this)
        this.deleteUnterrichtseinheit = this.deleteUnterrichtseinheit.bind(this)
        this.modalDeleteUE = this.modalDeleteUE.bind(this)
        this.registrierenContent = this.registrierenContent.bind(this)
        this.register = this.register.bind(this)
        this.saveNeuesProdukt = this.saveNeuesProdukt.bind(this)
        this.getProdukt_lektionen = this.getProdukt_lektionen.bind(this)
        this.produktlektionenContent = this.produktlektionenContent.bind(this)
        this.editProdukt = this.editProdukt.bind(this)
        this.deleteProdukt = this.deleteProdukt.bind(this)
        this.editAkkord = this.editAkkord.bind(this)
        this.modalDeleteProdukt = this.modalDeleteProdukt.bind(this)
        this.neuesProduktteil = this.neuesProduktteil.bind(this)
        this.zeigeLernvideos=this.zeigeLernvideos.bind(this)
        this.produktSuchen = this.produktSuchen.bind(this)
        this.zeigeProdukt = this.zeigeProdukt.bind(this)
        this.modalZeigeProduktDialog = this.modalZeigeProduktDialog.bind(this)
        this.closePlayer = this.closePlayer.bind(this)  
        this.unterrichtDiv = this.unterrichtDiv.bind(this)
        this.modalPdfDialog = this.modalPdfDialog.bind(this)
        this.inDenEinkaufswagen = this.inDenEinkaufswagen.bind(this)
        this.anmeldeSubMenu = this.anmeldeSubMenu.bind(this)
        this.gekauft = this.gekauft.bind(this)
        this.modalEinkaufswagen = this.modalEinkaufswagen.bind(this)
        this.getAlleBenutzerRegistriert = this.getAlleBenutzerRegistriert.bind(this)
        this.produkteZuordnen = this.produkteZuordnen.bind(this)
        this.einkauf = this.einkauf.bind(this)
        this.changeLektion = this.changeLektion.bind(this)
        this.fileUpload2 = this.fileUpload2.bind(this) 
  
        
    }
    
    


    anmeldeSubMenu(){

        var adminlink = null;
        var adminEinstellungenlink = null
        var schuelerEinstellungenlink = null
        var adminProduktlektionenLink = null
        
        if (this.state.activeUser!==undefined && this.state.activeUser !== null && this.state.activeUser.ist_admin===1){
            adminlink =               
                <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'admin'}, ()=>this.toggleNav())}><font color="b0b0b0">SCHÜLER-VERWALTUNG</font></button>
 
            adminEinstellungenlink=(
                <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'account'}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0090').toUpperCase()}</font></button>
         
            )   
            adminProduktlektionenLink = (
                <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'produktlektionen'}, ()=>this.toggleNav())}><font color="b0b0b0">PRODUKTE (Lektionen zum Verkauf oder Lernen)</font></button>
          
            )     
        }
        if (this.state.activeUser!==undefined && this.state.activeUser !== null && this.state.activeUser.ist_admin===0){
            schuelerEinstellungenlink = 
                <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:4}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0090').toUpperCase()}</font></button>
               
        }
        var meineAbosLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:1}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0215').toUpperCase()}</font></button>
        )
        var meineTaeglichenUebungenLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:2}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0221').toUpperCase()}</font></button>
        )
        var meinAktuellesAboLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:3}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0201').toUpperCase()}</font></button>
        )
        if (this.state.activeSchuelerAbo=== null){
            meinAktuellesAboLink = null
        }

        var meineakkordeLink =   <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:5}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0223').toUpperCase()}</font></button>

        var meineKaeufeLink =(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'meineAbos', schuelerPage:6}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0255').toUpperCase()}</font></button>
 
        )


        if (this.state.activeUser !== undefined &&  this.state.activeUser !== null  && this.state.activeUser.ist_admin===1){
            meineAbosLink=null
            meineTaeglichenUebungenLink = null
            meinAktuellesAboLink = null
            meineKaeufeLink = null
        }


        const menu =(
        <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true" style={{backgroundColor:'black'}}>
            <li className="nav-item">
                {adminEinstellungenlink}
                    {adminProduktlektionenLink}
                    {meineAbosLink}
                    {meineKaeufeLink}
                    {meineTaeglichenUebungenLink}
                    {meineakkordeLink}
                    {meinAktuellesAboLink}
                    {schuelerEinstellungenlink}              
                    {adminlink}

                    <div style={{backgroundColor:'lightgray', width:'100%', height:'2px'}} />
                    <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'home', isLoggedIn:false, activeUser:null, registername:'', registeremail:''})}><font color="b0b0b0">{this.getLanguageString('$STR_0076').toUpperCase()}</font></button>
 
            </li>
        </ul>
        )

       
        return (
            <Modal
            modalid="anmeldeSubMenu" 
            buttonid="anmeldeSubMenuButton" 
            body={menu}
            messagebox={true}
            backdrop={true}
            header={false}
            footer={false}
            modalStyle={{float:'right'}}
            backgroundstyle={{backgroundColor:'black'}}
            />
        )

      

    }

  
    setPlayer(player){
        this.setState({player})
    }

    closePlayer(){ 
            
        this.setState({youtubeVideo:null}, ()=>$('#modalZeigeProduktDialog').hide())
      
        $('.modal-backdrop').remove();  

        
    }

    inDenEinkaufswagen(produkt){
        if (this.state.einkaufswagen.indexOf(produkt)<0){
            const einkaufswagen = this.state.einkaufswagen
            einkaufswagen.push(produkt)
            this.setState({einkaufswagen})
            console.log("Einkauf", this.state.einkaufswagen)
        }
    }

    gekauft(produkt){
        let gekauft = false
        if (this.state.activeUser !==null){
            this.state.activeUser.benutzerKaeufe.forEach(
                (bk)=>{
                    if (bk.lektion_id=== produkt.id){
                        gekauft=true;
                    }
                }
            )
        }
        return gekauft
    }


    modalZeigeProduktDialog(){

        if (this.state.activeProduct === null) return null

        const src = `/media/albumthumbs/${this.state.activeProduct.cover_image}`

        let beschreibung = this.state.activeProduct.beschreibung_de
        if (this.state.language === "en") beschreibung = this.state.activeProduct.beschreibung_en
        if (this.state.language === "en") beschreibung = this.state.activeProduct.beschreibung_en
        if (this.state.language === "es") beschreibung = this.state.activeProduct.beschreibung_es
        if (this.state.language === "fr") beschreibung = this.state.activeProduct.beschreibung_fr
        if (this.state.language === "it") beschreibung = this.state.activeProduct.beschreibung_it
        if (this.state.language === "pt") beschreibung = this.state.activeProduct.beschreibung_pt     

        const _this = this        

        function uePils(ue){
            const id=`pills-${ue.id}-tab`
            const target = `#pills-${ue.id}-div`
            const controls=`pills-${ue.id}`

            const number = _this.state.activeProduct.unterrichtseinheiten.indexOf(ue) + 1

            let pillCaption = ue.thema
            if (_this.state.activeProduct.unterrichtseinheiten.length > 1){
                pillCaption = `${_this.getLanguageString('$STR_0251')} ${number} ${ue.thema}`
            }

            const key=`li${ue.id}`
            return(               
                <li key={key} className="nav-item" role="presentation">
                    <button className="nav-link" id={id} data-bs-toggle="pill" data-bs-target={target} type="button" role="tab" aria-controls={controls} aria-selected="false"><div style={{fontSize:'20px'}}>{pillCaption}</div> </button>
                </li>
            )            
        }

        let graydiv = null
        if (this.gekauft(this.state.activeProduct)===false){
            graydiv=(
                <>
                    <div style={{position:'absolute', top:'0', left:'0',width:'100%', height:'100%', backgroundColor:'black', opacity:'0.5' }} />
                    <div style={{color:'white', zIndex:'10', position:'absolute', top:'0', left:'0'}}>
                        <h3>{stringToHML(this.getLanguageString('$STR_0268'))}</h3>
                    </div>                
               </>
            )
        }


        function ueDivs(ue){
            const id=`pills-${ue.id}-div`
            const labelled = `pills-${ue.id}-tab`
            const number = _this.state.activeProduct.unterrichtseinheiten.indexOf(ue) + 1

            let contentPDF = <h3 style={{padding:'20px'}}>{_this.getLanguageString('$STR_0253')}</h3>
            if (ue.pdf_id > 0){

                let src = `https://franciscoguitar.de/media/pdf/${ue.pdf_id}.pdf`
                console.log(src)
               

                let iFrame = <iframe src={src} style={{width:'100%', minHeight:'800px', overflowY:'auto'}}></iframe>
                contentPDF=(
                    <div>
                        {iFrame}
                    </div>
                )
            }

            let contentVideo = <h3 style={{padding:'20px'}}>{_this.getLanguageString('$STR_0252')}</h3>
            if (ue.videourl !==""){
                let videosrc = `https://www.youtube.com/embed/${ue.videourl}?si=njewPk08XA8BPZAP&amp;start=${ue.video_ab_sec}&amp;end=${ue.video_ab_sec + ue.video_dauer}`
                if (ue.videourl.indexOf('.mp4')> -1){
                    videosrc = `http://185.75.164.170:3011/videos/${ue.videourl}`               
                 }
               

                contentVideo =(        
                        <iframe 
                            key={ue.id}
                            width="640" 
                            height="360" 
                            src={videosrc} 
                            title="YouTube video player" 
                            frameborder="0" 
                            allowfullscreen>                                
                        </iframe>
                )
            }

            let tabs = null

            if (ue.pdf_id > 0 && ue.videourl !==""){
                tabs=( 
                    <>
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">PDF</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">VIDEO</button>
                            </li>
                        </ul>                    
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">{contentPDF}</div>
                            <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">{contentVideo}</div>
                        </div>                    
                    </>
                )
            }
            if (ue.pdf_id === 0 && ue.videourl !==""){
                tabs=( 
                    <>
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">VIDEO</button>
                            </li>
                        </ul>                    
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade  show active" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">{contentVideo}</div>
                        </div>                    
                    </>
                )
            }
            if (ue.pdf_id > 0 && ue.videourl ===""){
                tabs=( 
                    <>
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">PDF</button>
                            </li>
                         </ul>                    
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">{contentPDF}</div>
                        </div>                    
                    </>
                )
            }

            
            
            const body=(
                <div>                   
                    {tabs}                  
                </div>
            )

            const key=`div${ue.id}`
            
            return(               
                 <div key={key} style={{position:'relative'}}  className="tab-pane fade" id={id} role="tabpanel" aria-labelledby={labelled} tabindex="0">{body}{graydiv}</div>
            )
        }

        let unterrichtseinheitenPills = null
        let unterrichtseinheitenDivs = null
        if (this.state.activeProduct.unterrichtseinheiten !== null ){
            unterrichtseinheitenPills = this.state.activeProduct.unterrichtseinheiten.map(uePils)
            unterrichtseinheitenDivs = this.state.activeProduct.unterrichtseinheiten.map(ueDivs)
        }

        let btnEinkaufswagen = <button style={{marginTop:'3px', float:'right'}} className="btn btn-primary btn-sm rounded-corners" onClick={()=>this.inDenEinkaufswagen(this.state.activeProduct)}><i className="material-icons"> shopping_cart </i>{this.getLanguageString('$STR_0254')} <div style={{ marginLeft:'10px', fontSize:'18px'}}>{this.state.activeProduct.preis.toFixed(2)} €</div></button>
        
        
        if (this.state.activeProduct.preis === 0 || this.gekauft(this.state.activeProduct) )  btnEinkaufswagen = null

        const divTitle=(
            <div style={{maxWidth:'100%'}}>
                <table>
                    <tbody>
                        <tr>                
                            <td style={{padding:'15px', fontSize:'18px', textAlign:'left'}}> {stringToHML(beschreibung)} </td>
                        </tr>                  
                        <tr>
                            <td>                           
                                    {this.state.youtubeVideo}                            
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )

        const closeButton =  <div onClick={this.closePlayer} className="btn btn-secondary" data-bs-dismiss="modal">{this.getLanguageString('$STR_0249')}</div>

        const windowheight = "calc(100vh - 220px)"

        console.log(windowheight);      

        let pdfPill = null
        let pdfDiv = null
        if (this.state.activeProduct.pdf_id > 0){

             let src = `https://franciscoguitar.de/media/pdf/${this.state.activeProduct.pdf_id}.pdf`
                console.log(src)
               

                let iFrame = <iframe src={src} style={{width:'100%', minHeight:'800px', overflowY:'auto'}}></iframe>
                let contentPDF=(
                    <div style={{position:'relative'}}>
                        {iFrame}
                        {graydiv}
                    </div>
                )

           

            pdfPill = 
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pdf-pill" data-bs-toggle="pill" data-bs-target="#pdf-div" type="button" role="tab" aria-controls="pills-pdf" aria-selected="false"><div style={{fontSize:'20px'}}>PDF</div> </button>
                </li>
            pdfDiv =(
                 <div className="tab-pane fade show " id="pdf-div" role="tabpanel" aria-labelledby="pdf-pill" tabindex="0">{contentPDF}</div>
            )
        }

       
        const body=(
            <div style={{color:'lightgrey', minHeight:'900px', overflowY:'auto'}}>
                  <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist" style={{marginTop:'5px', marginLeft:'10px', fontSize:'16px'}}>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">{this.getLanguageString('$STR_0052')}</button>
                    </li>
                    {pdfPill}
                    {unterrichtseinheitenPills}
                </ul>
                <div className="tab-content" id="pills-tabContent" style={{position:'relative'}}>
                   
                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">{divTitle}</div>
                    {pdfDiv}
                    {unterrichtseinheitenDivs}
                </div>
            </div>
        )

        return(
            <div className="showin"  style={{position:'fixed', width:'100%', height:'100%', top:'0', left:'0', zIndex:'6000', backgroundColor:'black', color:'lightgray', opacity:'1', textAlign:'center'}}>
                <h3 style={{marginLeft:'10px', marginTop:'10px'}}>{stringToHML(this.state.activeProduct.thema)}</h3>                    
                {body}
               <hr/>
                <div style={{bottom:'0', position:'fixed', width:'100%'}}>
                  {btnEinkaufswagen} <button style={{marginTop:'3px', float:'right'}} className="btn btn-secondary btn-sm rounded-corners" onClick={()=>this.setState({activePage:this.state.lastActivePage})}>{this.getLanguageString('$STR_0249')}</button>
                </div>
            </div>
        )     
    }


    produktSuchen(){

        if (this.state.suchenText===""){
            this.setState({filtered_produkt_lektionen: this.state.produkt_lektionen})
            return
        }

        let filtered_produkt_lektionen = []

        console.log(this.state.suchenText)

        this.state.produkt_lektionen.forEach(
            (lektion)=>{
                if (lektion.thema.toLowerCase().includes(this.state.suchenText.toLowerCase() )){
                    if (filtered_produkt_lektionen.indexOf(lektion) < 0){
                        filtered_produkt_lektionen.push(lektion)
                    }
                }
                if (lektion.stilrichtung !==null && lektion.stilrichtung !== "" && lektion.stilrichtung.toLowerCase().includes(this.state.suchenText.toLowerCase() )){
                    if (filtered_produkt_lektionen.indexOf(lektion) < 0){
                        filtered_produkt_lektionen.push(lektion)
                    }
                }
                if (lektion.stilrichtung2 !==null && lektion.stilrichtung2 !== "" && lektion.stilrichtung2.toLowerCase().includes(this.state.suchenText.toLowerCase() )){
                    if (filtered_produkt_lektionen.indexOf(lektion) < 0){
                        filtered_produkt_lektionen.push(lektion)
                    }
                }
            }
        )

        this.setState({filtered_produkt_lektionen})
    }

    zeigeProdukt(activeProduct, root){

        const _this = this
        console.log(activeProduct)  
        console.log(root)   

        let lastActivePage = "unterricht"
        if (root==="schuelerKauf"){
            lastActivePage = "meineAbos"
        }
   
        const youtubeVideo=<YoutubeVideo
                produkt={activeProduct}                
            />

        function showVideo(){
            //_this.setState({youtubeVideo}, ()=>$('#modalZeigeProduktDialogButton').click()) 
            _this.setState({youtubeVideo,activePage:"showProduct",lastActivePage,}) 
        }  
       
        this.setState({activeProduct, youtubeVideo:null}, ()=>showVideo())   
    }

    neuesProduktteil(){

        let unterrichtseinheit={
            id:0,
            lektion_id:this.state.activeLektion.id,
            thema:'neues Thema',
            bemerkungen:'',
            videourl:'',
            pdf_id:0,
            rangfolge:0,
            ist_oeffentlich:0,
            stilrichtung:'',
            lernziele:'',
            video_ab_sec:0,
            video_dauer:0,
        }
        axios.post('/api/unterrichtseinheiten', unterrichtseinheit)
        .then(
            result=>{
                let activeLektion = this.state.activeLektion
                this.state.activeLektion.unterrichtseinheiten = result.data
                this.setState({activeLektion})
            }
        )
    }

    editProdukt(lektion){
        console.log(lektion)
        this.setState({activeLektion:lektion},()=>{$('#modalNeuesProduktDialogButton').click()})
    }

    modalDeleteProdukt(){

        const _this = this
        if (this.state.activeLektion===null) return null

        function deleteProdukt(){
            const sql = `DELETE FROM frc_lektionen WHERE id=${_this.state.activeLektion.id}; DELETE FROM frc_unterrichtseinheiten WHERE lektion_id=${_this.state.activeLektion.id}`
            axios.post('/api/execcommonquery', {sql})
            .then(
                result=>{
                    _this.getProdukt_lektionen();
                }
            )
        }
        let body=`Dieses Produkt ${this.state.activeLektion.thema} löschen?`

        return(
            <Modal 
              modalid="modalDeleteProduktDialog" 
              buttonid="modalDeleteProduktDialogButton" 
              body={body}
              title="Produkt löschen"             
              okButtonenabled={true}  
              okButtonTitle="OK"
              closeButtonTitle="Abbrechen"
              okButtonClick={deleteProdukt}
           /> 
          )
    }

    deleteProdukt(lektion){

        this.setState({activeLektion:lektion}, function(){$('#modalDeleteProduktDialogButton').click()})
        

        

    }

    produktlektionenContent(){

   
        return(
            <Produkte
                produkt_lektionen={this.state.produkt_lektionen}
                neuesProdukt={this.neuesProdukt}
                editProdukt={this.editProdukt}
                deleteProdukt={this.deleteProdukt}
            />
           
        )

    }

    getProdukt_lektionen(){
        //abo_id = 1 => alle Produktlektionen laufen über dieses "Abo"
        axios.get('/api/lektionen/1')
        .then(
            result=>{
                if (result.data !== null){
                    this.setState({produkt_lektionen: result.data,filtered_produkt_lektionen:result.data})
                }
            }
        )

    }

    saveNeuesProdukt(){
        axios.post('/api/lektionen', this.state.activeLektion)
        .then(
            result=>{
                if (result.data !== null){
                    this.getProdukt_lektionen()
                }
            }
        )

    }

    register(){
        const _this = this

        const benutzerregistriert ={
            name: this.state.registername,
            email: this.state.registeremail,
        }

        axios.post('/api/benutzer/registrieren', benutzerregistriert)
        .then(
            result=>{
                if (result.data.id === 0){
                    this.setState({errortext:this.getLanguageString('$STR_0243')})
                }

                else{
                    $.ajax(
                        {
                            type: "POST",
                            url: "https://franciscoguitar.de/php/registrieren.php",
                            data: {
                                'name': this.state.registername, 
                                'email': this.state.registeremail, 
                                'passwort': result.data.passwort, 
                                'language':this.state.language
                            },
                            
                            success: function(html)
                            {
                                _this.setState({sentEmail:true, activeUser:result.data,isLoggedIn:true})
                                _this.getAlleBenutzerRegistriert()
                            
                            }
                        }
                    )
                }
            }
        )

        
        

    }

    registrierenContent(){
        let sendButton = <button className="btn btn-form btn-primary display-4" disabled>{this.getLanguageString('$STR_0080')}</button>    
        if (this.state.registername !== ""  && this.state.registeremail !== "")  {
            sendButton = <button className="btn btn-form btn-primary display-4" onClick={this.register}>{this.getLanguageString('$STR_0080')}</button>    
        }
        if (this.state.sentEmail){
            sendButton = <button data-bs-dismiss="modal" className="btn btn-form btn-primary display-4" >OK</button>    
        }

        let content =
         (
            <div className="form-1 col-md-12 col-sm-12" >
                <h2 className="mbr-fonts-style mbr-section-heading display-2">{this.getLanguageString('$STR_0238')}</h2>
                
                <p>{this.getLanguageString('$STR_0239')}</p>
                
                <div className="row row-sm-offset">

                    <div className="col-md-12 multi-horizontal" data-for="Name">
                        <div className="form-group">
                            <input type="text" className="form-control" onChange={(e)=>this.setState({registername:e.target.value})} placeholder={this.getLanguageString('$STR_0241')} data-form-field="Name" required="" id="email-form1-2" value={this.state.registername} />
                        </div>
                    </div>    
                    <font color="red"><strong>{this.state.errortext}</strong></font>

                    <div className="col-md-12 multi-horizontal" data-for="email">
                        <div className="form-group">
                            <input type="email" className="form-control" onChange={(e)=>this.setState({registeremail:e.target.value})} placeholder={this.getLanguageString('$STR_0028')} data-form-field="Email" required="" id="email-form1-2" value={this.state.registeremail} />
                        </div>
                    </div>                         
                </div>
                <p>{stringToHML(this.getLanguageString('$STR_0240'))}</p>

                <span className="input-group-btn">
                   {sendButton}
                </span>            
            </div>
        )

        if (this.state.sentEmail){
            content = (
                <div className="form-1 col-md-12 col-sm-12" >
                    <p className="mbr-fonts-style"><strong>{this.getLanguageString('$STR_0242')}</strong></p>     
                    {sendButton}              
                </div>               
            )
        }


        return content
    }

    deleteUnterrichtseinheit(unterrichtseinheit){
        this.setState({unterrichtseinheit}, function(){$('#modalDeleteUEDialogButton').click()})
    }

    isUserChord(id){
        let inList = false
        this.state.benutzer_akkorde.forEach(
            ba =>{
                if (ba.akkord_id === id){

                    inList = true
                }
            }
        )        
        return inList;
    }

    akkordeContent(){

        const _this = this

        let plusButton = null

        if (this.state.activeUser !==null && this.state.activeUser.ist_admin===1)
          plusButton = <button className="btn btn-primary" onClick={this.neuerAkkord}>Akkord +</button>
        

        function akkordRow(akkord){

            let editButton = null
            if (_this.state.activeUser !==null && _this.state.activeUser.ist_admin===1)
                editButton = <button  className="btn-sm-round btn-secondary" onClick={()=>_this.editAkkord(akkord)}><i className="material-icons"> edit </i></button>

            return(
                <div className="col" key={akkord.id}>                    
                    <Akkord
                        akkord={akkord}
                        language={_this.state.language}
                        isLoggedIn={_this.state.isLoggedIn}
                        isUserChord={(id)=>_this.isUserChord(id)}
                        changeAkkordeIds={_this.changeAkkordeIds}
                        getString={_this.getLanguageString}
                        editButton={editButton}
                    />
                </div>
            )
        }

        let info = null
        if (this.state.isLoggedIn===false){
            info = <div>{this.getLanguageString('$STR_0225')}</div>
        }

        return(
            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about7.png)'}}>
                <div className="container text-center showin" data-stellar-background-ratio=".5">
                    <div className="row slider-wrapper">
                        <div className="col-md-12">
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                                {info}
                                <h3>{this.getLanguageString('$STR_0223')}</h3>
                                    {plusButton}
                                <div className="row justify-content-center pt-5">
                                    {this.state.akkorde.map(akkordRow)}                                
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>            
            </section>
        )
    }

    getPdfs(){
        axios.get('/api/pdfs')
        .then(
            result=>{
                if (result.data !==null){
                    this.setState({pdfs: result.data})
                    console.log("pdfs", result.data)
                }
            }
        )
    }

    aboangebotsenden(){


        const _this = this

        let activeAbo = this.state.activeAbo
        activeAbo.angebot_versendet_am = new Date()

        function mailSenden(){

            $.ajax(
                {
                type: "POST",
                url: "https://franciscoguitar.de/php/angebotsenden.php",
                data: {'name': _this.state.activeSchueler.name, 'email': _this.state.activeSchueler.email, 'zusammenfassung': _this.state.activeAbo.angebot_html, 'language':_this.state.language, 'hinweis': _this.getLanguageString('$STR_0211'), 'anredezeile': _this.getLanguageString('$STR_0213')},
                
                success: function(html)
                {
                    _this.setState({activeAbo, messageText:html, messageTitle:"Angebot versendet"}, function(){$('#modalMessageBoxDialogButton').click()})
                
                }
                });
        }

        const sql=`UPDATE frc_unterricht_abos SET angebot_versendet_am=now() WHERE id=${this.state.activeAbo.id}`
        const array={sql}
        axios.post('/api/execcommonquery', array)
        .then(
            result=>{
                mailSenden()
            }
        )




    
    }

    sendeUnterrichtsanfrage(abo, schueler){

        const unterrichtabomitbenutzer = {
            unterrichtAbo:abo,
            benutzer:schueler 
        }        

        const _this = this     

     
        axios.post('/api/benutzer/unterrichtabomitbenutzer', unterrichtabomitbenutzer)
        .then(
            result=>{
               
            
                    $.ajax(
                        {
                        type: "POST",
                        url: "https://franciscoguitar.de/php/unterrichtsanfrage.php",
                        data: {'name': schueler.name, 'email': schueler.email, 'zusammenfassung': abo.angebot_html, 'language':this.state.language},
                        
                        success: function(html)
                        {
                            _this.setState({activeAbo:abo, activePage:"gitarrenschule"}, function(){$('#modalUnterrichtsAnfrageFertigDialogButton').click()})
                          
                        }
                        });
                
            }
        )

    }

    lektionSpeichern(){

        let activeLektion = this.state.activeLektion
       
        axios.post('/api/lektionen/lektionspeichern', activeLektion)
        .then(
            result2=>{
                if (result2.data !==null){
                    this.setState({activeLektion, lektionen:result2.data})
                   
                }
            }
        )

    }

fileUpload2( ){             
      
      const url = 'https://franciscoguitar.de/php/upload.php';
       
        let form_data = null
        let pdf = null

        if (this.state.file1 !== null){
            pdf = {
                id:0,
                dateiname:this.state.file1.name
            }            
            axios.post('/api/pdfs',pdf ) 
            .then(
                result=>{

                    form_data = new FormData();
                    form_data.append('file', this.state.file1);
                    form_data.append('filename', `${result.data}.pdf`);
                    axios.post(url, form_data)
                    .then(
                        res=>{
                            let activeLektion= this.state.activeLektion
                            activeLektion.pdf_id = result.data
                            activeLektion.dateinamepdf = this.state.file1.name
                            axios.post('/api/lektionen', activeLektion)
                            this.setState(activeLektion)
                        }
                    )
                }
            )           
        }    
    }


    fileUpload(ue ){             
      
      const url = 'https://franciscoguitar.de/php/upload.php';
       
        let form_data = null
        let pdf = null

        if (this.state.file1 !== null){
            pdf = {
                id:0,
                dateiname:this.state.file1.name
            }            
            axios.post('/api/pdfs',pdf ) 
            .then(
                result=>{

                    form_data = new FormData();
                    form_data.append('file', this.state.file1);
                    form_data.append('filename', `${result.data}.pdf`);
                    axios.post(url, form_data)
                    .then(
                        res=>{
                            let activeLektion= this.state.activeLektion
                            ue.pdf_id = result.data
                            ue.dateinamepdf = this.state.file1.name
                            axios.post('/api/unterrichtseinheiten', ue)
                            this.setState(activeLektion)
                        }
                    )
                }
            )           
        }    
    }

    modalEditLektion(){

        if(this.state.activeLektion===null) return null

        const lektion = this.state.activeLektion
        const _this = this
        

        function unterrichtseinheitRow(ue){

            function changePdfValue(value){
                const activeLektion = _this.state.activeLektion
                ue.pdf_id = value
                _this.setState({activeLektion})
            }
        
            function pdfRow(pdf){           
                return(
                    <button onClick={()=>changePdfValue(pdf.id)} className="dropdown-item">{pdf.dateiname}</button>    
                )
            }

            const dropDownPdfs =(
                <>
                    <button className="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown"  type="button" aria-expanded="false">
                        Pdf wählen
                    </button>
                    <ul className="dropdown-menu">
                    {_this.state.pdfs.map(pdfRow)}                
                    </ul>
                </>
            )

            function loeschen(){
                let activeLektion = _this.state.activeLektion
                axios.post('/api/unterrichtseinheiten/delete', ue)
                .then(
                    result=>{
                        activeLektion.unterrichtseinheiten = result.data
                        _this.setState({activeLektion})
                    }
                )
            }

            let dateinamepdf = null
            if (ue.pdf_id > 0) dateinamepdf = ue.dateinamepdf

            let buttonUpload =  <button className="btn btn-default" disabled>Hochladen</button>
            if (_this.state.file1 !== null){
                buttonUpload =  <button className="btn btn-default" onClick={()=>_this.fileUpload(ue)}>Hochladen</button>
            }

            const buttonDeleteUE = <button className="btn btn-warning" onClick={loeschen}>Unterrichtseinheit löschen</button>
          
            return(
                <>
                
                    <div className="form-group">
                        <label ><strong>Thema {ue.rangfolge}</strong></label>
                        <textarea className="form-control" rows={3}  name="thema" onChange={(e)=>_this.saveUnterrichtseinheit(e,ue.id)}  value={ue.thema} />
                    </div>     
                    <div>
                        <div style={{display:'flex'}}>
                            <div className="form-group" style={{width:'70%'}}>
                                <label>PDF(id) {dateinamepdf}</label>
                                <input className="form-control" type="number"  style={{width:'100px'}}  name="pdf_id" onChange={(e)=>_this.saveUnterrichtseinheit(e,ue.id)}  value={ue.pdf_id} />
                                <input type="file" accept="application/pdf" name="file1" id="selectFileButton"  onChange={(e)=>_this.setState({file1:e.target.files[0]}) }/>
                                {buttonUpload}
                                {dropDownPdfs}
                            </div>
                        </div>
                        <div style={{display:'flex'}}>
                            <div className="form-group" style={{width:'30%'}}>
                            <label>Video-ID</label>
                                <input className="form-control" type="text"  name="videourl" onChange={(e)=>_this.saveUnterrichtseinheit(e,ue.id)}  value={ue.videourl} />
                            </div>
                            <div className="form-group" style={{width:'70%'}}>
                            <label>Lernziele</label>
                                <textarea className="form-control" type="text" rows={3} name="lernziele" onChange={(e)=>_this.saveUnterrichtseinheit(e,ue.id)}  value={ue.lernziele} />
                            </div>
                            <div className="form-group" style={{width:'70%'}}>
                            <label>Bemerkungen</label>
                                <textarea className="form-control" type="text" rows={3} name="bemerkungen" onChange={(e)=>_this.saveUnterrichtseinheit(e,ue.id)}  value={ue.bemerkungen} />
                            </div>
                        </div>
                        {buttonDeleteUE}
                    </div>
                    <hr style={{backgroundColor:'green'}} />
                </>
            )
        }

        let unterrichtseinheiten = null
        if (lektion.unterrichtseinheiten !==null && lektion.unterrichtseinheiten !== undefined){
            unterrichtseinheiten = lektion.unterrichtseinheiten.map(unterrichtseinheitRow)
        }

        function neueUnterrichtseinheit(){

            let activeLektion = _this.state.activeLektion

            const ue={
                id:0,
                lektion_id:lektion.id,
                thema:'Neues Thema',
                pdf_id:0,
                videourl:'',
                bemerkungen:'',
                rangfolge:0,
                ist_oeffentlich:0,
                stilrichtung:'',
                lernziele:'',
                video_ab_sec:0,
                video_dauer:0,

            }
            axios.post('/api/unterrichtseinheiten', ue)
            .then(
                result=>{     
                    _this.getLektionen(_this.state.activeAbo.id)
                    activeLektion.unterrichtseinheiten = result.data;
                    _this.setState(activeLektion)
                }   
            )
        }

        const body=(
            <div>
                <h4>Lektion {lektion.lfdnr}</h4> 
                 
                 <div style={{display:'flex'}}>
                    <div className="form-group" style={{width:'200px'}}>
                        <label htmlFor="untdatum">Datum</label>         
                        <input id="untdatum" className="form-control" type="datetime-local" name="unterrichtszeit"  onChange={(e)=>this.saveUnterrichtseinheit(e,lektion.id)}  value={lektion.unterrichtszeit}  />
                    </div>          
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox"  name="ist_abgeschlossen" role="switch" onChange={(e)=>this.saveUnterrichtseinheit(e,lektion.id)} checked={lektion.ist_abgeschlossen===1} />
                        <label className="form-check-label" for="flexSwitchCheckDefault">Die Lektion ist abgeschlossen</label>
                        
                    </div>
                </div>
                

                <hr/>
                {unterrichtseinheiten}   
                <button className="btn btn-primary"  onClick={neueUnterrichtseinheit}>Neue Unterrichtseinheit +</button>          
            </div>
        )
    
        return(
    
            <Modal
                modalid="modalEditLektionDialog"
                buttonid="modalEditLektionDialogButton"   
                title="Lektion bearbeiten" 
                body={body} 
                okButtonTitle="Lektion speichern"
                okButtonClick={this.lektionSpeichern}
                closeButtonTitle="Abbrechen"
                modalLarge={true}
            />
        )
    }

    modalActiveSchuelerAboDialog(){    
        if (this.state.activeSchuelerAbo === null || this.state.activeSchuelerAbo===undefined) return null       

        const body=(
            <div>
                <center>
                 {stringToHML(this.state.activeSchuelerAbo.angebot_html)}
                </center>
            </div>
        )

        return(
    
            <Modal
                modalid="modalActiveSchuelerAboDialog"
                buttonid="modalActiveSchuelerAboDialogButton"   
                title={this.getLanguageString('$STR_0220')} 
                body={body} 
                messagebox={true}
                closeButtonTitle="OK"
                modalLarge={true}
            />
        )
    }

    checkUnterrichtsAnfrageAnnehmen(){

        const _this = this
        const sql = `UPDATE frc_unterricht_abos SET angenommen_am=now() WHERE id=${this.state.angebotSchuelerAbo.id}`
        const array={sql}
        axios.post('/api/execcommonquery', array);

        const angebotSchuelerAbo = this.state.angebotSchuelerAbo
        angebotSchuelerAbo.angenommen_am= new Date()


        $.ajax(
            {
            type: "POST",
            url: "https://franciscoguitar.de/php/angebotannehmen.php",
            data: {'name': _this.state.activeUser.name, 'email': _this.state.activeUser.email, 'zusammenfassung': angebotSchuelerAbo.angebot_html, 'language':_this.state.language},
            
            success: function(html)
            {
                 const messageText=<div><big>{_this.getLanguageString('$STR_0219')}</big><p>{_this.getLanguageString('$STR_0143')}</p><p>Francisco</p> </div>
       
                _this.setState({angebotSchuelerAbo, zahlungsBedingungenGelesen:false, messageTitle:'', messageText}, function(){$('#modalMessageBoxDialogButton').click()})
            
            }
            });
       
       

    }


    modalAngebotSchuelerAboDialog(){    
        if (this.state.angebotSchuelerAbo === null || this.state.angebotSchuelerAbo===undefined) return null      
        
        let  bestellFehlerText = null
        if (this.state.zahlungsBedingungenGelesen===false){
            bestellFehlerText = this.getLanguageString('$STR_0218')
        }

        const body=(
            <div>
                {stringToHML(this.state.angebotSchuelerAbo.angebot_html)}
                <font color="red"><b>{bestellFehlerText}</b></font>
                <div className="form-check form-switch">
                    <input className="form-check-input"  type="checkbox" onChange={()=>this.setState({zahlungsBedingungenGelesen : !this.state.zahlungsBedingungenGelesen})} role="switch" id="flexSwitchCheckDefault" checked={this.state.zahlungsBedingungenGelesen===true}/>
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{this.getLanguageString('$STR_0217')}</label>
                </div>
                            
            </div>
        )

        let okButton = <button onClick={this.checkUnterrichtsAnfrageAnnehmen} data-bs-dismiss="modal" className="btn btn-primary">{this.getLanguageString('$STR_0216')}</button>
        if (this.state.zahlungsBedingungenGelesen===false){
            okButton = <button disabled className=" btn btn-primary">{this.getLanguageString('$STR_0216')}</button>
        }

        return(
    
            <Modal
                modalid="modalAngebotSchuelerAboDialog"
                buttonid="modalAngebotSchuelerAboDialogButton"   
                title={this.getLanguageString('$STR_0210')} 
                body={body} 
                modalLarge={true}
                closeButtonTitle={this.getLanguageString('$STR_0184')}
                okButton={okButton}
            />
        )
    }

    editLektion(id){
        this.state.lektionen.forEach(
            lektion=>{
                if (lektion.id===id){
                   this.setState({activeLektion:lektion}, function(){$('#modalEditLektionDialogButton').click()})
                }
            }
        )
    }

    saveUE(e, ue){
        if (e.target.name==="thema") ue.thema = e.target.value;
        if (e.target.name==="pdf_id") {
            ue.pdf_id = Number(e.target.value);
        }
        if (e.target.name==="bemerkungen") ue.bemerkungen = e.target.value;
        if (e.target.name==="videourl") ue.videourl = e.target.value;
        if (e.target.name==="lernziele") ue.lernziele = e.target.value;        
    }

    saveUnterrichtseinheit(e, ueid){
       
        let activeLektion= this.state.activeLektion      
        if (e.target.name==="unterrichtszeit") activeLektion.unterrichtszeit = e.target.value; 
        if (e.target.name==="ist_abgeschlossen") {            
            activeLektion.ist_abgeschlossen = 0
            if (e.target.checked)activeLektion.ist_abgeschlossen = 1
        }

        activeLektion.unterrichtseinheiten.forEach(
            ue=>{
                if (ue.id===ueid){
                    this.saveUE(e, ue)                   
                    axios.post('/api/unterrichtseinheiten', ue)
                }
            }
        )
        this.setState({activeLektion})       
    }

    getLektionen(aboid){

        const _this = this

        this.setState({lektionen:[]}, function(){

            axios.get('/api/lektionen/' + aboid)
                    .then(
                        result=>{
                            if (result.data !==null){
                                
                                 _this.setState({lektionen: result.data}) 
                                
                                
                                
                            }
                        }
                    )


        })

        

    }

    neuesAbo(){

        const neuesAbo={
            id:0,
            benutzer_id:this.state.activeSchueler.id,
            benutzer2_id:0,
            kursthema_id:0,
            unterrichtsort_id:2,
            altersgruppe:'erwachsene',
            lektionsdauer:45,
            gruppenunterricht:0,
            anzahl_lektionen:5,
            rabatt:0,
            unterrichtszeit:'',
            preis_pro_lektion:62,
            datum_beginn_abo:null,
            datum_ende_abo:null,
            bemerkungen:'',
            gesamtpreis:0,
            wegpauschale:0,
            andererschueler:'',
            andererschueler_email:'',
            status:'angebot',
            angebot_html:'',
            angenommen_am:null,
            zahlungsbedingungen:''

        }
        axios.post('/api/unterrichtabos', neuesAbo)
        .then(
            result=>{
                let activeSchueler = this.state.activeSchueler
                activeSchueler.unterrichtabos = result.data
                result.data.forEach(
                    abo=>{
                        if (abo.kursthema_id===0){
                            this.setState({activeSchueler, activeAbo:abo, activeLektion:null, lektionen:[]})
                        }
                    }
                )
                
            }
        )
    }

    saveAbo(abo){

        

        axios.post('/api/unterrichtabos', abo)
        .then(
            result=>{
                if (result.data !== null){
                    let activeSchueler = this.state.activeSchueler
                    activeSchueler.unterrichtabos = result.data
                    this.setState({activeSchueler, activeAbo: abo})
                }               
            }
        )
    }

    changeAbo(e){
        
        let activeAbo = this.state.activeAbo
        if (e.target.name==="gruppenunterricht"){
            activeAbo.gruppenunterricht=0
            if (e.target.checked)activeAbo.gruppenunterricht=1
        }
        
        if (e.target.name==="andererschueler")activeAbo.andererschueler=e.target.value
        if (e.target.name==="andererschueler_email")activeAbo.andererschueler_email=e.target.value
        if (e.target.name==="anzahl_lektionen")activeAbo.anzahl_lektionen=e.target.value
        if (e.target.name==="datum_beginn_abo")activeAbo.datum_beginn_abo=e.target.value
        if (e.target.name==="datum_ende_abo")activeAbo.datum_ende_abo=e.target.value
        if (e.target.name==="unterrichtszeit")activeAbo.unterrichtszeit=e.target.value
        if (e.target.name==="bemerkungen")activeAbo.bemerkungen=e.target.value
        if (e.target.name==="zahlungsbedingungen")activeAbo.zahlungsbedingungen=e.target.value
        if (e.target.name==="gesamtpreis")activeAbo.gesamtpreis=Number(e.target.value)
        if (e.target.name==="wegpauschale")activeAbo.wegpauschale=Number(e.target.value)
        

        this.setState({activeAbo}) 

        if (e.target.name==="anzahl_lektionen"){
            this.getLektionen(activeAbo.id)
        }

    }

    setAboStatus(value){
        let activeAbo = this.state.activeAbo
        activeAbo.status = value 
        this.setState({activeAbo}) 
    }

    setLektionsdauer(value){
        let activeAbo = this.state.activeAbo
        activeAbo.lektionsdauer = value 
        this.setState({activeAbo}) 
    }

    setAltersgruppe(value){
        let activeAbo = this.state.activeAbo
        activeAbo.altersgruppe = value 
        this.setState({activeAbo}) 
    }

    setAnzahlstunden(value){
        let activeAbo = this.state.activeAbo
        activeAbo.anzahl_lektionen = value 
        this.setState({activeAbo}) 
    }

    setUnterrichtsort(value){
        let activeAbo = this.state.activeAbo
        activeAbo.unterrichtsort_id = value 
        this.setState({activeAbo}) 
    }

    setKursthemaid(value){
        let activeAbo = this.state.activeAbo
        activeAbo.kursthema_id = value 
        this.setState({activeAbo}) 
    }

    schuelerLoeschen(){
        
        const array={
            sql:`DELETE FROM frc_benutzer WHERE id=${this.state.activeSchueler.id}; DELETE FROM frc_unterricht_abos WHERE benutzer_id=${this.state.activeSchueler.id}`
        }


        axios.post('/api/execcommonquery', array)
        .then(
            result=>{
                
                   this.getSchueler()
                   $('.modal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass( "modal-open" );      

               
            }
        )
    }

    neuerSchueler(){
        const neuerSchueler={
            id:0,
            email:'',
            name:'Neuer Schüler',
            anmelder_name:'',
            ist_admin:0,
            status:'angemeldet',
            strassenr:'',
            plzort:'',
            telefon:'',
            bemerkungen:'',
            geburtsjahr:0
        }
        axios.post('/api/benutzer',neuerSchueler )
        .then(
            result=>{
                if (result.data !==null){
                    result.data.forEach(
                        sch=>{
                            if (sch.name==="Neuer Schüler"){
                                this.setState({schueler: result.data, activeSchueler:sch})

                            }
                        }
                    )
                }
            }
        )

    }

    saveSchueler(){
        const schueler={
            id:this.state.activeSchueler.id,
            email:this.state.activeSchueler.email,
            name:this.state.activeSchueler.name,
            ist_admin:this.state.activeSchueler.ist_admin,
            status:this.state.activeSchueler.status,
            strassenr:this.state.activeSchueler.strassenr,
            plzort:this.state.activeSchueler.plzort,
            telefon:this.state.activeSchueler.telefon,
            bemerkungen:this.state.activeSchueler.bemerkungen,
            geburtsjahr:this.state.activeSchueler.geburtsjahr
        }
        axios.post('/api/benutzer', schueler)
        .then(
            result=>{
                if (result.data !== null){
                    result.data.forEach(
                        (sch)=> {
                            if (sch.email===this.state.activeSchueler.email){
                                this.setState({schueler: result.data, activeSchueler:sch})
                            }
                        }
                    )                    
                }
            }
        )
    }

    changeSchuelerStatus(status){
        let activeSchueler = this.state.activeSchueler
        activeSchueler.status = status
        this.setState({activeSchueler})

    }

    changeSchuelerData(e){

        let activeSchueler = this.state.activeSchueler
        if (e.target.name==="name" )activeSchueler.name=e.target.value
        if (e.target.name==="anmelder_name" )activeSchueler.anmelder_name=e.target.value
        if (e.target.name==="email" )activeSchueler.email=e.target.value
        if (e.target.name==="telefon" )activeSchueler.telefon=e.target.value
        if (e.target.name==="strassenr" )activeSchueler.strassenr=e.target.value
        if (e.target.name==="plzort" )activeSchueler.plzort=e.target.value
        if (e.target.name==="geburtsjahr" )activeSchueler.geburtsjahr=e.target.value
        if (e.target.name==="bemerkungen" )activeSchueler.bemerkungen=e.target.value
        if (e.target.name==="andererschueler" )activeSchueler.andererschueler=e.target.value
        this.setState({activeSchueler})
    }

    getSchueler(){
        const _this = this
        axios.get('/api/benutzer')
        .then(
            result=>{
                if (result.data !== null){   
                    result.data.forEach(
                        (sch)=> {
                            if (this.state.activeSchueler!==null && sch.email===this.state.activeSchueler.email){
                                this.setState({activeSchueler:sch})                                
                            }                           
                        }                        
                    )                       
                    
                    this.setState({schueler: result.data}, function(){_this.setSchuelerFilter(_this.state.schuelerFilter)})
                }
            }
        )
    }

    setSchuelerFilter(filter){
        let filteredSchueler = []
        
        this.state.schueler.forEach(
            (schueler)=>{
                if (filter=='alle') filteredSchueler.push(schueler)
                if (filter=='aktiv' && schueler.status==='aktiv') filteredSchueler.push(schueler)                
                if (filter=='inaktiv' && schueler.status==='inaktiv')filteredSchueler.push(schueler)
                if (filter=='angemeldet' && schueler.status==='angemeldet')filteredSchueler.push(schueler)  
            }
        )
        this.setState({filteredSchueler, schuelerFilter: filter, activeSchueler:null})

    }

    sendeAnfrage(value){

        const _this = this
        $.ajax(
            {
            type: "POST",
            url: "https://franciscoguitar.de/php/kontakt.php",
            data: {'anfrage_name': this.state.anfrage_name, 'anfrage_email': this.state.anfrage_email, 'anfrage_telefon': this.state.anfrage_telefon, 'anfrage_text': this.state.anfrage_text},
            
            success: function(html)
            {
               
                _this.setState({sentEmail:true,anfrage_name:'',anfrage_email:'', anfrage_text:'', anfrage_telefon:''})
              
            }
            });
    }

    contactContent(){

        let sendButton =  <button  onClick={()=>this.sendeAnfrage()} className="btn btn-form btn-primary font-header">{this.getLanguageString('$STR_0031')}</button>
        if (this.state.anfrage_email === "" && this.state.anfrage_name==="" && this.state.anfrage_text===""){
            sendButton =  <button className="btn btn-form btn-primary " disabled >{this.getLanguageString('$STR_0031')}</button>
        }

        const placeholderName= `${this.getLanguageString('$STR_0027')} *`;
        const placeholderEmail= `${this.getLanguageString('$STR_0028')} *`;
        const placeholderAnfrage= `${this.getLanguageString('$STR_0030')} *`;


        let form = (
            <>
                <h2 className="mbr-fonts-style mbr-section-heading font-header">{this.getLanguageString('$STR_0098')}</h2>
                <br/>
                {this.getLanguageString('')}<br/>
    
                <h4 style={{color: 'rgb(45, 45, 45)'}}>Tel. DE +49.1573.9245419<br/></h4><br />
                
            


                <input type="hidden" name="kontakt_anfrage" value="1" />
        
                <div className="row input-main">
                    <div className="col-md-6 input-wrap" data-for="vorname_name">
                        <input type="text" className="field normal-font form-control" onChange={(e)=>this.setState({anfrage_name:e.target.value})} data-form-field="Name" placeholder={placeholderName} required="" id="name-form2-u" value={this.state.anfrage_name} />
                    </div>
                    <div className="col-md-6 input-wrap" data-for="email">
                        <input type="email" className="field normal-font form-control" onChange={(e)=>this.setState({anfrage_email:e.target.value})}  data-form-field="Email" placeholder={placeholderEmail} required="" id="email-form2-u" value={this.state.anfrage_email}/>
                    </div>
                    <div className="col-md-6 input-wrap" data-for="telefon">
                        <input type="text" className="field normal-font form-control" onChange={(e)=>this.setState({anfrage_telefon:e.target.value})}  data-form-field="Telefon" placeholder={this.getLanguageString('$STR_0275')}  id="email-form3-u" value={this.state.anfrage_telefon}/>
                    </div>
                </div>

                <div className="form-group" data-for="message">
                    <textarea type="text" className="form-control normal-font form-control" onChange={(e)=>this.setState({anfrage_text:e.target.value})}  rows="7" placeholder={placeholderAnfrage} required="" data-form-field="Message" id="message-form2-u">{this.state.anfrage_text}</textarea>
                </div>
                <span className="input-group-btn">        
                   {sendButton}
                </span>
            </>

        )


        let backButton = null
        if (window.location.pathname === "/concert"){
             backButton =  <p><a href="/concert"   className="btn btn-form btn-primary font-header" >{this.getLanguageString('$STR_0274')}</a></p>
        }

        if (this.state.sentEmail){
            form = (
                <>
                    <h4>{this.getLanguageString('$STR_0038')}</h4>
                    {backButton}
                </>
            )
        }


        let content = (
            <div className="container text-center showin" data-stellar-background-ratio=".5">
                <div className="row slider-wrapper">
                    <div className="col-md-12" >
                        <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                            <div className="row justify-content-center pt-5">                                    
                              {form}
                             
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        )



        return(
            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/sanchis.png)'}}>    
                {content}
            </section>
        )
    }



    musicContent(){

        function stueckerow(stueck){

            return(
                <tr><td>{stueck.titel}</td><td>{stueck.komponist}</td></tr>
            )

        }

         const soundcloudFrame=<><iframe width="100%" height="150" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2294287505&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style={{fontSize: '100', color: '#cccccc',lineBreak: 'anywhere', wordBreak: 'normal', overflow: 'hidden', whiteSpace: 'nowrap',textOverflow: 'ellipsis', fontWeight: '100'}}><a href="https://soundcloud.com/herbert-815652219" title="Francisco plays" target="_blank" style={{color: '#cccccc', textDecoration: 'none'}}>Francisco</a> · <a href="https://soundcloud.com/herbert-815652219/mantilladeferia-c-2miclr" title="MantillaDeFeria" target="_blank" style={{color: '#cccccc', textDecoration: 'none'}}>MantillaDeFeria</a></div></>


          const content3 = (

          <>
         
            <h2 className="styled color-francisco" style={{textTransform:'uppercase', marginTop:'50px'}}><strong>{this.getLanguageString('$STR_0270')} {this.getLanguageString('$STR_0269')} »Francisco«</strong></h2>
            
            <div style={{textAlign:'left'}}><h3>Paco de Lucía</h3>
            <p style={{fontSize:'1.2rem'}}>Punta Umbria (Fandangos), Monasterio del Sal (Colombiana), Mi Inspiración (Alegría), Mi niño Curro (Rondeña), Barrio la viña (Alegría), Doblan Campanas (Rondeña), Guajiras de Lucía (Guajira), Almoraima (Bulería)</p>
            </div>
        
     <div style={{textAlign:'left', marginTop:'20px'}}><h3>Paco Peña</h3>
            <p style={{fontSize:'1.2rem'}}>El nuevo día (Colombiana), La Lola (Rumba), Los veleros (Alegría), Mantilla y peina (Guajora), Riomar (Fandangos), Salobre (Malagueña)  </p>
            </div>

        
     <div style={{textAlign:'left', marginTop:'20px'}}><h3>Francisco Tárrega</h3>
            <p style={{fontSize:'1.2rem'}}>Capricho Arabe, Danza Mora, Recuerdos de la Alhambra, Lágrima</p>
            </div>


        
     <div style={{textAlign:'left', marginTop:'20px'}}><h3>Francisco</h3>
            <p style={{fontSize:'1.2rem'}}>Gongora (Siguiriya), Malolo (Bulería), La Alba (Rumba), Caimari (Alegría), Puente Isabel (Sevllana)</p>
            </div>
            </>
          )

        

        const content2=(
                <div  className="html5gallery" data-skin="light" data-width="700" data-height="430">
                    <a href="/assets/images/cd3_.jpg"><img src="/assets/images/cd3.jpg" alt={this.getLanguageString('$STR_0054')} /></a>
                    <a href="/assets/images/cd8_.jpg"><img src="/assets/images/cd8.jpg" alt={this.getLanguageString('$STR_0055')}/></a>
                    <a href="/assets/images/cd1_.jpg"><img src="/assets/images/cd1.jpg" alt={this.getLanguageString('$STR_0056')}/></a>
                    <a href="/assets/images/cd2_.jpg"><img src="/assets/images/cd2.jpg" alt={this.getLanguageString('$STR_0057')}/></a>
                    <a href="/assets/images/cd5_.jpg"><img src="/assets/images/cd5.jpg" alt={this.getLanguageString('$STR_0058')}/></a>
                    <a href="/assets/images/cd6_.jpg"><img src="/assets/images/cd6.jpg" alt={this.getLanguageString('$STR_0059')}/></a>
                    <a href="/assets/images/cd9_.jpg"><img src="/assets/images/cd9.jpg" alt=""/></a>
                    <a href="/assets/images/cd10_.jpg"><img src="/assets/images/cd10.jpg" alt=""/></a>
                </div>
        )

     


        return(
            <>
            
                <div className="container text-center showin" data-stellar-background-ratio=".1" style={{color:'rgb(200,200,200'}}>
                    <div className="row slider-wrapper">
                        <div className="col-12">
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                 <div>
                                    <img className="card-big"  style={{width:'100%',margin:'auto', marginBottom:'25px'}} src="/assets/images/herbertfranziskaner.jpg" />
                                </div>                                
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>  
                                <h2   className="styled">Herbert »Francisco« Dapper</h2>
                                <big className="color-francisco" style={{marginTop:'15px'}}>{this.getLanguageString('$STR_0273')}</big>
                                <div style={{textAlign:'center'}}><p className="normal-font" style={{marginTop:'25px'}}>{stringToHML(this.getLanguageString('$STR_0271'))}</p></div>
                                <img className="card" src="/assets/images/gitarrestuehle.jpg" style={{width:'100%', margin:'auto'}} />          
                            </div>
                        </div>
                        <a name="francisco"></a>
                        <div className="col-12" style={{marginTop:'10px'}}>
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                 {content3}
                            </div>
                        </div>
                        <div className="col-12" style={{marginTop:'10px'}}>
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                  <div><iframe style={{width:'100%', aspectRatio:'16 / 9', height:'auto' }} src="https://www.youtube.com/embed/Amx1jB0179g?si=7e1ZkGlvXUekSXLR" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="true"></iframe></div>
                                  <div style={{marginTop:'20px'}}>{soundcloudFrame}</div>
                            </div>
                        </div>

                        {this.contactContent()}    
                    </div>
                </div> 
                           
             
           
            
            </>
        )
    }

    neuesPasswortSpeichern(){
        

        if (this.state.password1!==this.state.password2){
            this.setState({errortext:<><font color="red"><strong>{this.getLanguageString('$STR_0094')}</strong></font></>})
            return
        }

        let sql = `UPDATE frc_benutzer SET passwort=password('${this.state.password1}'), name='${this.state.benutzername}' WHERE id=${this.state.activeUser.id}`
        if (this.state.password1 === ""){
            sql = `UPDATE frc_benutzer SET name='${this.state.benutzername}' WHERE id=${this.state.activeUser.id}`
        }       

        axios.post('/api/execcommonquery', {sql})
        .then(
            result=>{
                const activeUser = this.state.activeUser
                activeUser.name = this.state.benutzername
                this.setState({errortext:this.getLanguageString('$STR_0095'), activeUser})
            }
        )      

    }

    sendNewPassword(){
       
        axios.get('/api/benutzer/passwortvergessen/'+ this.state.forgotemail)
        .then(
            result=>{
                if (result.data.id===0){
                    this.setState({errortext:this.getLanguageString('$STR_0081')})

                }
                else{
                    
                    const url =  "https://franciscoguitar.de/php/passwortvergessen.php"
                    const _this = this
                    $.ajax({
                        url ,
                        data: {'passwort': result.data.passwort, 'email': this.state.forgotemail, 'language': this.state.language},   
                        type : 'POST',
                        success : function (result) {
                           _this.setState({sentEmail: true})
                        },
                        error : function () {
                           console.log ('error');
                        }
                   
                      });

                }
            }
        )
    }

    passwortvergessenContent(){

   
        let sendButton =  <button className="btn btn-form btn-primary display-4" onClick={this.sendNewPassword}  >{this.getLanguageString('$STR_0080')} </button>
        if (this.state.forgotemail===""){
            sendButton = <button className="btn btn-form btn-primary display-4" disabled>{this.getLanguageString('$STR_0080')}</button>
        }       



        let form = (
            <div className="form-1 col-md-12 col-sm-12" >
                <h2 className="mbr-fonts-style mbr-section-heading display-2">{this.getLanguageString('$STR_0078')}</h2>
                {this.state.errortext}
                <p>{this.getLanguageString('$STR_0079')}</p>
                
                <div className="row row-sm-offset">

                    <div className="col-md-12 multi-horizontal" data-for="email">
                        <div className="form-group">
                            <input type="email" className="form-control" onChange={(e)=>this.setState({forgotemail:e.target.value})} placeholder={this.getLanguageString('$STR_0028')} data-form-field="Email" required="" id="email-form1-2" value={this.state.forgotemail} />
                        </div>
                    </div>                         
                </div>

                <span className="input-group-btn">
                   {sendButton}
                </span>            
            </div>

        )

        let content = form

        if (this.state.sentEmail){
            content = (
                <div className="form-1 col-md-12 col-sm-12" >
                    <h2 className="mbr-fonts-style mbr-section-heading display-2">{this.getLanguageString('$STR_0088')}</h2>                   
                </div>               
            )
        }

      
        return content;
       

    }

    accountContent(){
        const  saveButton =  <button onClick={this.neuesPasswortSpeichern} className="btn btn-form btn-primary display-4">{this.getLanguageString('$STR_0093')}</button>
        
        
        if (this.state.activeUser !== null && this.state.activeUser.ist_admin===1){
            return(
                <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background showin" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about5.png)'}}>
                    <div className="container text-center" data-stellar-background-ratio=".5">
                        <div className="row slider-wrapper">
                            <div className="col-md-12" >
                                <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                                    <div className="row justify-content-center pt-5">
                                        <h2 className="mbr-fonts-style mbr-section-heading display-2">{this.getLanguageString('$STR_0089')}</h2>
                                        <p>{this.getLanguageString('$STR_0096')} {this.state.activeUser.name}</p><br/>                                
                                        <div className="row row-sm-offset">
                                            {this.state.errortext}
                                            <div className="col-md-12 multi-horizontal" data-for="password1">
                                                <div className="form-group">
                                                    <input type="password" className="form-control" onChange={(e)=>this.setState({password1:e.target.value})} placeholder={this.getLanguageString('$STR_0091')} data-form-field="password1" required="" id="password-form1-2" value={this.state.password1} />
                                                </div>
                                            </div>
                                            <div className="col-md-12 multi-horizontal" data-for="password2">
                                                <div className="form-group">
                                                    <input type="password" className="form-control" onChange={(e)=>this.setState({password2:e.target.value})} placeholder={this.getLanguageString('$STR_0092')} required="" data-form-field="password2" id="password1-form1-2"  value={this.state.password2} />
                                                </div>
                                            </div>
                                            </div>

                                            <span className="input-group-btn">
                                            {saveButton}
                                            </span>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </section>
            )
        }

        
        if (this.state.activeUser !== null && this.state.activeUser.ist_admin===0){
            return(
                <div style={{backgroundColor:'white', padding:'20px'}}>
                    <center>
                        <h2 className="mbr-fonts-style mbr-section-heading display-2">{this.getLanguageString('$STR_0089')}</h2>
                        <p>{this.getLanguageString('$STR_0096')} {this.state.activeUser.name}</p>
                        <p>{this.getLanguageString('$STR_0227')}</p>                              
                        <div className="row row-sm-offset">
                            {this.state.errortext}

                            <div className="col-md-12 multi-horizontal" data-for="benutzername1">
                                <div className="form-group">
                                    
                                    <input type="text" className="form-control" onChange={(e)=>this.setState({benutzername:e.target.value})} placeholder={this.getLanguageString('$STR_0241')} data-form-field="benutzername1" required="" id="benutzername1-form1-2" value={this.state.benutzername} />
                                </div>
                            </div>
                            <div className="col-md-12 multi-horizontal" data-for="password1">
                                <div className="form-group">
                                    <input type="password" className="form-control" onChange={(e)=>this.setState({password1:e.target.value})} placeholder={this.getLanguageString('$STR_0091')} data-form-field="password1" required="" id="password-form1-2" value={this.state.password1} />
                                </div>
                            </div>
                            <div className="col-md-12 multi-horizontal" data-for="password2">
                                <div className="form-group">
                                    <input type="password" className="form-control" onChange={(e)=>this.setState({password2:e.target.value})} placeholder={this.getLanguageString('$STR_0092')} required="" data-form-field="password2" id="password1-form1-2"  value={this.state.password2} />
                                </div>
                            </div>
                        </div>
                        <span className="input-group-btn">
                            {saveButton}
                        </span>
                    </center>
                </div>
                                           
            )
        }
    }

    eingeloggtContent(){

        return(
            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about5.png)'}}>
            <div className="container text-center" data-stellar-background-ratio=".5">
                <div className="row slider-wrapper">
                    <div className="col-md-12" >
                        <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                            <div className="row justify-content-center pt-5">
                                {this.getLanguageString('$STR_0075')}
                                
                                <div>
                                <a href="#" onClick={()=>this.setState({activePage:'lessons'})} className="btn btn-primary">OK</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </section>
        )

    }


    checkLogin(){

        const benutzer={
            email:this.state.email,
            passwort: this.state.passwort
        }

        axios.post('/api/benutzer/check', benutzer)
       .then(
            result=>{
                if (result.data.id===0){
                    this.setState({errortext:this.getLanguageString('$STR_0074'), isLoggedIn:false})                   
                }
                else{     
                    console.log(result.data)
                    $('#modalLogindialogButton').click()           
                    this.setState({activeUser:result.data, benutzername:result.data.name,registername:result.data.name, registeremail:result.data.email, isLoggedIn:true})  

                    axios.get('/api/lektionen/benutzer/' + result.data.id)
                    .then(
                        result2=>{
                            if (result2.data !== null){                         
                                this.setState({schueler_lektionen: result2.data})                       
                            }
                        }
                    )
                    this.getTaeglicheLektion(result.data.id)
                   
                    
                    axios.get('/api/unterrichtabos/'+ result.data.id)
                    .then(
                        result3=>{
                            if (result3.data !== null) {
                                let activeSchuelerAbo = null
                                let angebotSchuelerAbo = null
                                result3.data.forEach(
                                    abo=>{
                                        if (abo.status==='aktiv'){
                                            activeSchuelerAbo = abo
                                        }
                                        if (abo.status==='angebot'){
                                            angebotSchuelerAbo = abo
                                        }
                                    }
                                )
                                this.setState({schuelerAbos: result3.data, activeSchuelerAbo,angebotSchuelerAbo})   
                            }                 
                                                         
                        }
                    )

                    const _this = this

                    this.getBenutzerAkkorde(result.data.id)

                   

                    let activePage="meineAbos"
                    if (result.data.ist_admin===1)activePage="admin"
                   
                    this.setState({ errortext:'', isLoggedIn:true, activePage})
                }
                
            }
       )

    }

    getTaeglicheLektion(userid){
        axios.get('/api/lektionen/benutzer/taeglichelektion/' + userid)
        .then(
            result4=>{
                if (result4.data !== null){                         
                    this.setState({schueler_taeglicheLektion: result4.data})  
                }
            }
        )
    }

    getBenutzerAkkorde(benutzer_id){
        const _this = this
         axios.get('/api/akkorde/' + benutzer_id)
        .then(
            result4=>{
                if (result4.data !== null){                         
                    this.setState({benutzer_akkorde: result4.data}, function(){_this.sortiereBenutzerAkkorde(result4.data)})                                                      
                }
            }
        )
    }

    loginContent(){

        let okButton = <button  className="btn btn-form btn-primary normal-font" onClick={this.checkLogin}   >{this.getLanguageString('$STR_0031')}</button>
        if (this.state.email === "" || this.state.passwort===""){
            okButton = <button  className="btn btn-form btn-primary normal-font" disabled   >{this.getLanguageString('$STR_0031')}</button>
        }        

        let form=(
            <div className="form-1 col-md-12 col-sm-12" >
              
                {this.state.errortext}
                <div className="row row-sm-offset">
                    <div className="col-md-12" data-for="email">
                        <div className="form-group">
                            <input type="email" className="form-control normal-font" onChange={(e)=>this.setState({email:e.target.value})} placeholder="Email" data-form-field="Email" required="" id="email-form1-2" value={this.state.email} />
                        </div>
                    </div>
                    <div className="col-md-12" data-for="password">
                        <div className="form-group">
                            <input type="password" className="form-control normal-font" onChange={(e)=>this.setState({passwort:e.target.value})}  placeholder={this.getLanguageString('$STR_0073')} required="" data-form-field="password" id="password-form1-2"  value={this.state.passwort} />
                        </div>
                    </div>
                </div>
                <span className="input-group-btn">
                    {okButton}
                </span>     
                <hr/>
                <div>
                    <a className="btn btn-form btn-link" onClick={()=>this.setState({registrieren:true})} href="#">{this.getLanguageString('$STR_0238')}</a>
                </div>    
                <div >
                    <a className="btn btn-form btn-link"  onClick={()=>this.setState({passwortvergessen:true})} href="#">{this.getLanguageString('$STR_0078')}</a>
                </div>    
            </div>
        )

        let content =(            
            <div className="container text-center" data-stellar-background-ratio=".5">
                <div className="row slider-wrapper">
                    <div className="col-md-12" >
                        <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                            <div className="row justify-content-center pt-5">
                                    {form}
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        )

        return content

       
    }

    toggleNav(){
        
        if (this.navBarHeight() > 50){
                    $('#toggler').click()
                    
        }
        this.getAkkorde()  
        this.sortiereBenutzerAkkorde(this.state.benutzer_akkorde)
    }

    neueUnterrichtsanfrage(){    

        this.setState({activeAbo:null})
        this.toggleNav()
        this.setState({
            activeAbo:{
                id:0,
                benutzer_id:0,
                benutzer2_id:0,
                kursthema_id:1,
                unterrichtsort_id:2,
                altersgruppe:'erwachsene',
                lektionsdauer:45,
                gruppenunterricht:0,
                anzahl_lektionen:5,
                rabatt:0,
                unterrichtszeit:'',
                preis_pro_lektion:62,
                datum_beginn_abo:null,
                datum_ende_abo:null,
                bemerkungen:'',
                gesamtpreis:0,
                wegpauschale:0,
                andererschueler:'',
                andererschueler_email:'',
                status:'anfrage',
                angebot_html:'',
                angenommen_am:null,
                angebot_versendet_am:null,
                zahlungsbedingungen:''
            },
            activePage:'unterrichtsanfrage',
            activeSchueler:{
                id:0,
                email:'',
                name:'',
                passwort:'',
                anmelder_name:'',
                ist_admin:0,
                status:'angemeldet',
                strassenr:'',
                plzort:'',
                telefon:'',
                bemerkungen:'',
                geburtsjahr:0,
                
            },
            showLernvideos:false
        })

    }

    unterrichtDiv(){
   
        let divLernvideos=null
        if (this.state.showLernvideos){
            divLernvideos=(
                <div className="col row-item">                        
                <img src="/assets/images/sheetmusic.png" />                          
                    <h3 className="styled">{this.getLanguageString('$STR_0128')}</h3>
                    <div className="separator"></div>
                    <p className="normal-font">{this.getLanguageString('$STR_0250')}</p>
                    <a className="btn btn-primary" href="#" onClick={this.zeigeLernvideos} >{this.getLanguageString('$STR_0128').toUpperCase()}</a>
            </div>
            )
        }

        return(
            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about4.png)'}}>
                <div className="container text-center showin" data-stellar-background-ratio=".5">
                <div className="row slider-wrapper">
                    <div className="col-md-12">
                        <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>    
                            <div className="row justify-content-center pt-5">

                                <div className="col row-item">                       
                                    <img src="/assets/images/teacher.png" />                          
                                    <h3 className="styled">{this.getLanguageString('$STR_0122')}</h3>
                                    <div className="separator"></div>
                                    <p>{this.getLanguageString('$STR_0036')}</p>
                                    <a className="btn btn-primary" href="#" onClick={this.neueUnterrichtsanfrage}>{this.getLanguageString('$STR_0122').toUpperCase()}</a>
                                </div>                            
                        
                               {divLernvideos}

                                <div className="col row-item">   
                                <img src="/assets/images/concert.png"/>                               
                                        <h3 className="styled">{this.getLanguageString('$STR_0223').toUpperCase()}</h3>
                                        <div className="separator"></div>
                                      
                                        <a className="btn btn-primary" href="#"  onClick={()=>this.setState({activePage:'akkorde'})} >{this.getLanguageString('$STR_0223').toUpperCase()}</a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div> 
                </div>
                
         
            
            </section>
        )
    }

    unterrichtsMenu(){     

        var unterrichtsanfrageLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={this.neueUnterrichtsanfrage}><font color="b0b0b0">{this.getLanguageString('$STR_0122').toUpperCase()}</font></button>
        )
        var zeigeLernvideosLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={this.zeigeLernvideos}><font color="b0b0b0">{this.getLanguageString('$STR_0128').toUpperCase()}</font></button>
        )
        if (this.state.showLernvideos===false){
            zeigeLernvideosLink = null
        }
        var akkordeLink=(
            <button className="text-warning dropdown-item display-4" data-bs-dismiss="modal" onClick={()=>this.setState({activePage:'akkorde'}, ()=>this.toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0223').toUpperCase()}</font></button>
        )

     
    

        const menu =(
            <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true" style={{backgroundColor:'black'}}>
                <li className="nav-item">
                    {unterrichtsanfrageLink}
                    {zeigeLernvideosLink}
                    {akkordeLink}
                </li>
            </ul>
        )

        var cumulativeOffset = function(element) {
            var top = 0, left = 0;
            do {
                top += element.offsetTop  || 0;
                left += element.offsetLeft || 0;
                element = element.offsetParent;
            } while(element);
        
            return {
                top: top,
                left: left
            };
        };

        let modalStyle = null       

        let umenu = document.getElementById("unterrichtsmenu")
        let offset
        if (umenu !== null){
            offset = cumulativeOffset(umenu)
            let screenWidth = window.screen.width
            let top=`${offset.top}px`
            let left=`${offset.left}px`
            modalStyle = {marginLeft:left, marginTop:top}
        }
       
           
            return (
                <Modal
                modalid="unterrichtsMenu" 
                buttonid="unterrichtsMenuButton" 
                body={menu}
                messagebox={true}
                backdrop={true}
                header={false}
                footer={false}
                modalStyle={modalStyle}
                backgroundstyle={{backgroundColor:'black'}}
                />
            )
    
    }

    zeigeLernvideos(){
        this.toggleNav()
        this.setState({activePage:'unterricht'})

    }

    navBarHeight(){
        let navbarSupportedContent = document.getElementById("navbarSupportedContent")
        let navHeight = 30;
        if (navbarSupportedContent !== null){           
            navHeight = navbarSupportedContent.offsetHeight
        }
        return navHeight


    }

    componentDidUpdate(){ 
    }

    anmeldeMenu(){
       
        let toggleNav = ()=>function(){}
        if (this.navBarHeight() > 50){
            toggleNav = ()=>function(){$('#toggler').click()}
        }

        const _this = this

        let anmeldeLink = 
            <li className="nav-item">
                <a className="nav-link link text-warning nav-font" href="#" onClick={()=>this.setState({errortext:false, passwortvergessen:false,registrieren:false, sentEmail:false}, function(){_this.showModalLoginDoalog()})}>{this.getLanguageString('$STR_0066').toUpperCase()}</a>
            </li>
        
        
        if (this.state.activeUser !== undefined &&  this.state.activeUser !== null){

            anmeldeLink=(
                <li id="anmeldenavitem"  className="nav-item">
                  <a className="nav-link nav-font link dropdown-toggle text-warning nav-font" href="#" onClick={()=>$('#anmeldeSubMenuButton').click()}>{this.getLanguageString('$STR_0089').toUpperCase()}</a>
                </li>
       
        )
        
          /* anmeldeLink = 
            <li id="anmeldemenu" className="nav-item dropdown">
                <a className="nav-link link text-warning dropdown-toggle nav-font" href="#" id="navbarDropdown"  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {this.getLanguageString('$STR_0089').toUpperCase()}
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                    {adminEinstellungenlink}
                    {adminProduktlektionenLink}
                    {meineAbosLink}
                    {meineTaeglichenUebungenLink}
                    {meinAktuellesAboLink}
                    {schuelerEinstellungenlink}              
                    {adminlink}
                    <div className="dropdown-divider"></div>
                    <a className="text-warning dropdown-item display-4" href="#" onClick={()=>this.setState({activePage:'home', isLoggedIn:false, activeUser:null}, toggleNav())}><font color="b0b0b0">{this.getLanguageString('$STR_0076').toUpperCase()}</font></a>
                 </div>
            </li>     */     

          

        }


        // nur fürs testen
   //     anmeldeLink = <li className="nav-item"><a className="text-warning dropdown-item display-4" onClick={()=>this.setState({activePage:'admin'})} href="#">Admin</a></li>

        return anmeldeLink;   
    }

    
   

    getStrings(){      
        
        axios.get('/api/languagestrings')
        .then(
            result =>{
                if (result.data !== null){
                    this.setState({strings: result.data})
                   
                }
            }
        )
       
       
    }

    getLanguageString(value){
       
        var result = ''       
        this.state.strings.forEach(
            array =>{                          
                if (array.number.trim()=== value) {
                    
                    if (this.state.language==='de') result = array.lang_de
                    if (this.state.language==='en') result = array.lang_en
                    if (this.state.language==='es') result = array.lang_es
                    if (this.state.language==='fr') result = array.lang_fr
                    if (this.state.language==='it') result = array.lang_it
                    if (this.state.language==='pt') result = array.lang_pt
                }              
            }           
        )
        if (result !== null)       
        return result.replaceAll("\\", "");

        return null;
    }


    componentWillMount(){

        const _this = this

        
        

        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = ()=> {
        if (xhr.readyState == 4 && xhr.status == 200) {
            console.log("xhr geladen", xhr.responseText)
            let showLernvideos = xhr.responseText === "show=true"           
            this.setState({showLernvideos})
            }
        }
        xhr.open('GET', 'lernvideos.config');
        xhr.send();

       
   
       this.getStrings()

      this.getPdfs()
    
        axios.get('/api/hello/server')
        .then(
            result=>{          
                this.setState({server:result.data,})
            }
        )
        

       axios.get('/api/repertoire')
        .then(
            result=>{
                if (result.data !== null){
                    this.setState({repertoire: result.data})
                }
            }
        )

        this.setSchuelerFilter('aktiv')

        var language = 'en'

        const locale = new Intl.Locale(navigator.language);

        switch (locale.language) {
            case 'de':
                language = 'de'
                break;
            case 'es':
                language = 'es'
                break;
            case 'fr':
                language = 'fr'
                break;
            case 'it':
                language = 'it'
                break;
            case 'pt':
                language = 'pt'
                break;
        
        }
       
        this.setState({language}, function (){_this.getAkkorde()  })

        axios.get('/api/kursthemen')
        .then(
            result=>{
                if (result.data !== null){
                    this.setState({kursthemen:result.data})
                }
            }
        )
        axios.get('/api/unterrichtsorte')
        .then(
            result=>{
                if (result.data !== null){
                    this.setState({unterrichtsorte:result.data})
                }
            }
        )
        axios.get('/api/lektionenpreise')
        .then(
            result=>{
                if (result.data !== null)
                    this.setState({lektionenpreise: result.data})
            }
        )

        
        axios.get('/api/unterrichtabos/aktive')
        .then(
            result=>{
                if (result.data !== null)
                    this.setState({aktiveAbos: result.data})
            }
        )

        this.getProdukt_lektionen()

        this.getSchueler()


        this.getAlleBenutzerRegistriert()
        

    }

    getAlleBenutzerRegistriert(){
        axios.get('/api/benutzer/allebenutzerregistriert')
        .then(
            result=>{
                console.log(result.data)
                if (result.data !== null)
                    this.setState({alleBenutzerRegistriert: result.data})
            }
        )
    }

    sortiereBenutzerAkkorde(akkorde){
        if (this.state.language==="de"){
            akkorde.sort(function (a, b) {
                if (a.name_de < b.name_de) {
                return -1;
                }
                if (a.name_de > b.name_de) {
                return 1;
                }
                return 0;
            });
        }
        else{
            akkorde.sort(function (a, b) {
                if (a.name_en < b.name_en) {
                return -1;
                }
                if (a.name_en > b.name_en) {
                return 1;
                }
                return 0;
            });
        }
    }

    getAkkorde(){
         axios.get('/api/akkorde')
        .then(
            result=>{    
                let akkorde = result.data
                if (this.state.language==="de"){
                    akkorde.sort(function (a, b) {
                        if (a.name_de < b.name_de) {
                        return -1;
                        }
                        if (a.name_de > b.name_de) {
                        return 1;
                        }
                        return 0;
                    });
                }
                else{
                    akkorde.sort(function (a, b) {
                        if (a.name_en < b.name_en) {
                        return -1;
                        }
                        if (a.name_en > b.name_en) {
                        return 1;
                        }
                        return 0;
                    });
                }

                this.setState({akkorde})
            }
        )
    }

    modalUnterrichtsAnfrageFertig(){

        if (this.state.activeAbo === null) return null

        const body=(
            <>
            <h4>{this.getLanguageString('$STR_0148')}</h4>
            <p>{this.getLanguageString('$STR_0145')} {this.getLanguageString('$STR_0143')}</p>
            {stringToHML(this.state.activeAbo.angebot_html)}
            </>
        )

        return(
          <Modal 
            modalid="modalUnterrichtsAnfrageFertigDialog" 
            buttonid="modalUnterrichtsAnfrageFertigDialogButton" 
            body={body}
            title={this.getLanguageString('$STR_0109')}
            messagebox={true}
            okButtonenabled={true}  

         /> 
        )
    }

    changeLektion(e){

            console.log(e.target.name)
            console.log(e.target.value)

            if (this.state.activeLektion === null){
                console.log("activeLektion === null")
            }
            if (this.state.activeLektion === undefined){
                console.log("activeLektion === undefined")
            }

            const activeLektion = this.state.activeLektion
            
            if (e.target.name==="thema")activeLektion.thema = e.target.value
            if (e.target.name==="beschreibung_de")activeLektion.beschreibung_de = e.target.value
            if (e.target.name==="beschreibung_en")activeLektion.beschreibung_en = e.target.value
            if (e.target.name==="beschreibung_es")activeLektion.beschreibung_es = e.target.value
            if (e.target.name==="beschreibung_fr")activeLektion.beschreibung_fr = e.target.value
            if (e.target.name==="beschreibung_it")activeLektion.beschreibung_it = e.target.value
            if (e.target.name==="beschreibung_pt")activeLektion.beschreibung_pt = e.target.value
          
          
            if (e.target.name==="stilrichtung")activeLektion.stilrichtung = e.target.value
            if (e.target.name==="stilrichtung2")activeLektion.stilrichtung2 = e.target.value
            if (e.target.name === "videourl")activeLektion.videourl = e.target.value
            if (e.target.name === "video_ab_sec")activeLektion.video_ab_sec = e.target.value
            if (e.target.name === "video_dauer")activeLektion.video_dauer = e.target.value
            if (e.target.name==="suchbegriffe") activeLektion.suchbegriffe = e.target.value


            if (e.target.name==="ist_technische_uebung"){
                activeLektion.ist_technische_uebung = 0
                if (e.target.checked) activeLektion.ist_technische_uebung = 1
            }


            if (e.target.name === "standardcover"){
                activeLektion.standardcover = 0
                if (e.target.checked){
                    activeLektion.standardcover = 1
                    activeLektion.cover_image = "albumthumbnail.png"
                    if (activeLektion.ist_technische_uebung===1){
                            activeLektion.cover_image = "guitarexercise.png"
                    }
                }
            }

            if (e.target.name==="ist_oeffentlich"){
                activeLektion.ist_oeffentlich = 0
                if (e.target.checked) activeLektion.ist_oeffentlich = 1
            }
            if (e.target.name==="ist_aktiv"){
                activeLektion.ist_aktiv = 0
                if (e.target.checked) activeLektion.ist_aktiv = 1
            }



            if (e.target.name==="preis") {
                console.log(e.target.value)
                activeLektion.preis = parseFloat(e.target.value)
            }

            if (e.target.name==="file1"){
                activeLektion.cover_image = e.target.files[0].name
            }   
            
          

            this.setState({activeLektion})

    }

    modalNeuesProduktDialog(){

        if (this.state.activeLektion === null) return null

        const activeLektion = this.state.activeLektion

        const _this = this
        


        const beschreibung_navs=(
            <>
                <ul className="nav nav-tabs" id="myTab2" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="beschreibungde-tab" data-bs-toggle="tab" data-bs-target="#beschreibungde" type="button" role="tab" aria-controls="beschreibungde" aria-selected="true">Beschreibung DE</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="beschreibungen-tab" data-bs-toggle="tab" data-bs-target="#beschreibungen" type="button" role="tab" aria-controls="beschreibungen" aria-selected="false">Beschreibung EN</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="beschreibunges-tab" data-bs-toggle="tab" data-bs-target="#beschreibunges" type="button" role="tab" aria-controls="beschreibunges" aria-selected="false">Beschreibung ES</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="beschreibungfr-tab" data-bs-toggle="tab" data-bs-target="#beschreibungfr" type="button" role="tab" aria-controls="beschreibungfr" aria-selected="false">Beschreibung FR</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="beschreibungit-tab" data-bs-toggle="tab" data-bs-target="#beschreibungit" type="button" role="tab" aria-controls="beschreibungit" aria-selected="false">Beschreibung IT</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="beschreibungpt-tab" data-bs-toggle="tab" data-bs-target="#beschreibungpt" type="button" role="tab" aria-controls="beschreibungpt" aria-selected="false">Beschreibung PT</button>
                </li>
                </ul>
                <div className="tab-content" id="myTabContent2" style={{textAlign:'left'}}>
                    <div className="tab-pane fade show active" id="beschreibungde" role="tabpanel" aria-labelledby="beschreibungde-tab"><textarea rows={6} name="beschreibung_de" className="form-control" value={activeLektion.beschreibung_de} onChange={this.changeLektion} /></div>
                    <div className="tab-pane fade" id="beschreibungen" role="tabpanel" aria-labelledby="beschreibungen-tab"><textarea rows={6} name="beschreibung_en" className="form-control" value={activeLektion.beschreibung_en} onChange={this.changeLektion} /></div>
                    <div className="tab-pane fade" id="beschreibunges" role="tabpanel" aria-labelledby="beschreibunges-tab"><textarea rows={6} name="beschreibung_es" className="form-control" value={activeLektion.beschreibung_es} onChange={this.changeLektion} /></div>
                    <div className="tab-pane fade" id="beschreibungfr" role="tabpanel" aria-labelledby="beschreibungfr-tab"><textarea rows={6} name="beschreibung_fr" className="form-control" value={activeLektion.beschreibung_fr} onChange={this.changeLektion} /></div>
                    <div className="tab-pane fade" id="beschreibungit" role="tabpanel" aria-labelledby="beschreibungit-tab"><textarea rows={6} name="beschreibung_it" className="form-control" value={activeLektion.beschreibung_it} onChange={this.changeLektion} /></div>
                    <div className="tab-pane fade" id="beschreibungpt" role="tabpanel" aria-labelledby="beschreibungpt-tab"><textarea rows={6} name="beschreibung_pt" className="form-control" value={activeLektion.beschreibung_pt} onChange={this.changeLektion} /></div>
                </div>
            </>

        )

        let thumb = null
        if (activeLektion.cover_image !==""){
            let src=`/media/albumthumbs/${activeLektion.cover_image}`
            thumb = <img className="card"  src={src} width="100" />
        }
        if (activeLektion.standardcover===1){
            thumb = <img src="/media/albumthumbs/albumthumbnail.png" width="100" />
            if (activeLektion.ist_technische_uebung===1)
                thumb = <img src="/media/albumthumbs/guitarexercise.png" width="100" />
        }

         let buttonUpload2 =  <button className="btn btn-default" disabled>Hochladen</button>
            if (this.state.file1 !== null){
                buttonUpload2 =  <button className="btn btn-default" onClick={()=>this.fileUpload2()}>Hochladen</button>
            }

        function changePdfValue2(id, dateiname){
            const activeLektion = _this.state.activeLektion
            activeLektion.pdf_id = id
            activeLektion.dateinamepdf=dateiname
            _this.setState({activeLektion})
            document.getElementById('fileInput').value= null;
            const sql=`UPDATE frc_lektionen SET pdf_id = '${id}' WHERE id=${_this.state.activeLektion.id}`
            axios.post('/api/execcommonquery', {sql})
        }

        function pdfRow2(pdf){           
                return(
                    <button onClick={()=>changePdfValue2(pdf.id,pdf.dateiname)} className="dropdown-item">{pdf.dateiname}</button>    
                )
            }

        const dropDownPdfs =(
                <>
                    <button  className="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown"  type="button" aria-expanded="false">
                        Pdf wählen
                    </button>
                    <ul className="dropdown-menu">
                    {this.state.pdfs.map(pdfRow2)}                
                    </ul>
                </>
            )



        const head=(
            <div>
                <table className="table">
                    <tbody>
                        <tr>
                            <td width={120}>Thema/Titel</td><td><input type="text" name="thema" className="form-control"  value={activeLektion.thema} onChange={this.changeLektion} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{beschreibung_navs}</td>
                        </tr>                       
                        <tr>
                            <td>Stilrichtung</td><td><input type="text" name="stilrichtung" className="form-control" value={activeLektion.stilrichtung} onChange={this.changeLektion} /></td>
                        </tr>                      
                        <tr>
                            <td>Stilrichtung 2</td><td><input type="text" name="stilrichtung2" className="form-control" value={activeLektion.stilrichtung2} onChange={this.changeLektion} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" name="ist_oeffentlich" role="switch" onChange={this.changeLektion} checked={activeLektion.ist_oeffentlich===1} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault"> wird veröffentlicht </label>
                                </div>
                            </td>                        
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault2" name="ist_technische_uebung" role="switch" onChange={this.changeLektion} checked={activeLektion.ist_technische_uebung===1} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault2"> technische Übung </label>
                                </div>
                            </td>                        
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault3" name="ist_aktiv" role="switch" onChange={this.changeLektion} checked={activeLektion.ist_aktiv===1} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault3"> ist_aktiv </label>
                                </div>
                            </td>                        
                        </tr>
                        <tr>
                            <td>Preis</td><td><input style={{width:'100px'}} type="number" step="0.1" name="preis" className="form-control" value={activeLektion.preis} onChange={this.changeLektion} /></td>
                        </tr>
                        <tr>
                            <td>Youtube-ID</td>
                            <td>
                                <div style={{display:'flex'}}>
                                    <input style={{width:'300px'}} type="text" name="videourl" className="form-control" value={activeLektion.videourl} onChange={this.changeLektion} />
                                    <input style={{width:'100px'}} type="number" name="video_ab_sec" className="form-control" value={activeLektion.video_ab_sec} onChange={this.changeLektion} />
                                    <input style={{width:'100px'}} type="number" name="video_dauer" className="form-control" value={activeLektion.video_dauer} onChange={this.changeLektion} />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Cover<br/>{thumb}</td><td>
                                <input type="file" accept="image/png" name="file1" onChange={this.changeLektion}/>

                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" name="standardcover" role="switch" onChange={this.changeLektion} checked={activeLektion.standardcover===1} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault"> Standard-Cover </label>
                                </div>
                                <p>{activeLektion.cover_image}</p>
                            </td>                               
                        </tr>
                        <tr>
                                <td>PDF {activeLektion.dateinamepdf}</td>
                                <td> <input type="file"  id="fileInput" accept="application/pdf" name="file1"  onChange={(e)=>_this.setState({file1:e.target.files[0]}) }/>
                                    {buttonUpload2} {dropDownPdfs}
                                </td>
                            </tr>
                        <tr>
                            <td>Suchbegriffe</td>
                            <td>
                                <textarea className="form-control" rows={3} name="suchbegriffe" value={activeLektion.suchbegriffe} onChange={this.changeLektion}  />
                            </td>
                        </tr>
                        
                    </tbody>
                </table>


            </div>
        )

        let title ="Neues Produkt"
        if (this.state.activeLektion.id > 0){
            title = "Produkt bearbeiten"
        }

        function unterrichtsEinheitTab(ue){

            const tabID= `tab-${ue.id}`
            const divID=`div-${ue.id}`
            const divRef = `#div-${ue.id}`

            const num = _this.state.activeLektion.unterrichtseinheiten.indexOf(ue) + 1

            return(
                <li className="nav-item">
                    <a className="nav-link" id={tabID} data-bs-toggle="tab" href={divRef} role="tab" aria-controls={divID} aria-selected="false">{num}. {ue.thema}</a>
                </li>
            )
        }

        function changeUE(e){
            let activeLektion = _this.state.activeLektion
            if (e.target.name === "thema") _this.state.unterrichtseinheit.thema = e.target.value
            if (e.target.name === "lernziele") _this.state.unterrichtseinheit.lernziele = e.target.value
            if (e.target.name === "videourl") _this.state.unterrichtseinheit.videourl = e.target.value
            if (e.target.name === "video_ab_sec") _this.state.unterrichtseinheit.video_ab_sec = e.target.value
            if (e.target.name === "video_dauer") _this.state.unterrichtseinheit.video_dauer = e.target.value    


            _this.setState(activeLektion)
            const sql=`UPDATE frc_unterrichtseinheiten SET ${e.target.name} = '${e.target.value}' WHERE id=${_this.state.unterrichtseinheit.id}`
            axios.post('/api/execcommonquery', {sql})
        }

        function unterrichtsEinheitDiv(ue){

            let dateinamepdf = null
            if (ue.pdf_id > 0) dateinamepdf = ue.dateinamepdf

            let buttonUpload = null
            if (_this.state.file1 !== null){
                buttonUpload =  <button className="btn btn-info" onClick={()=>_this.fileUpload(ue)}>Hochladen</button>
            }

            function changePdfValue(id, dateiname){
                const unterrichtseinheit = _this.state.unterrichtseinheit
                unterrichtseinheit.pdf_id = id
                unterrichtseinheit.dateinamepdf=dateiname
                _this.setState({unterrichtseinheit})
                document.getElementById('fileInput').value= null;
                const sql=`UPDATE frc_unterrichtseinheiten SET pdf_id = '${id}' WHERE id=${_this.state.unterrichtseinheit.id}`
                axios.post('/api/execcommonquery', {sql})
            }

            function pdfRow(pdf){           
                return(
                    <button onClick={()=>changePdfValue(pdf.id,pdf.dateiname)} className="dropdown-item">{pdf.dateiname}</button>    
                )
            }

            const dropDownPdfs =(
                <>
                    <button onFocus={()=>_this.setState({unterrichtseinheit:ue})}    className="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown"  type="button" aria-expanded="false">
                        Pdf wählen
                    </button>
                    <ul className="dropdown-menu">
                    {_this.state.pdfs.map(pdfRow)}                
                    </ul>
                </>
            )

            const tabID= `tab-${ue.id}`
            const divID=`div-${ue.id}`
            return(
                <div className="tab-pane fade" id={divID} role="tabpanel" aria-labelledby={tabID}>

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>Thema</td>
                                <td><textarea rows={2} onFocus={()=>_this.setState({unterrichtseinheit:ue})}  className="form-control" name="thema"  value={ue.thema} onChange={changeUE}  /></td>
                            </tr>
                            <tr>
                                <td>Lernziele</td>
                                <td><textarea rows={3} onFocus={()=>_this.setState({unterrichtseinheit:ue})} className="form-control" name="lernziele"  value={ue.lernziele} onChange={changeUE}  /></td>
                            </tr>
                            <tr>
                                <td>Video</td>
                                <td>
                                    <div style={{display:'flex'}}>
                                        <div className="form-group" style={{width:'200px'}}>
                                            <label htmlFor="youtube-id">Youtube-ID</label>
                                            <input type="text" className="form-control"  id="youtube-id" onFocus={()=>_this.setState({unterrichtseinheit:ue})} value={ue.videourl} name="videourl" onChange={changeUE} />
                                        </div>
                                        <div style={{width:'15px'}}/>
                                        <div className="form-group" style={{width:'100px'}}>
                                            <label htmlFor="video-spielen">spielen ab Sek.</label>
                                            <input type="number" className="form-control" id="video-spielen" onFocus={()=>_this.setState({unterrichtseinheit:ue})} value={ue.video_ab_sec} name="video_ab_sec" onChange={changeUE} />
                                        </div>
                                        <div style={{width:'15px'}}/>
                                        <div className="form-group" style={{width:'100px'}}>
                                            <label htmlFor="video_dauer">Spieldauer</label>
                                            <input type="number" className="form-control" id="video_dauer" onFocus={()=>_this.setState({unterrichtseinheit:ue})}  value={ue.video_dauer} name="video_dauer" onChange={changeUE} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>PDF {ue.dateinamepdf}</td>
                                <td> <input type="file"  id="fileInput" accept="application/pdf" name="file1"  onChange={(e)=>_this.setState({file1:e.target.files[0]}) }/>
                                    {buttonUpload} {dropDownPdfs}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
        }

        let tabs = null
        let divs=null
        if (this.state.activeLektion.unterrichtseinheiten !== undefined){
            tabs = this.state.activeLektion.unterrichtseinheiten.map(unterrichtsEinheitTab)
            divs = this.state.activeLektion.unterrichtseinheiten.map(unterrichtsEinheitDiv)
        }
        const  navs =(
                <>
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Produkt</a>
                        </li>
                        {tabs}                   
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">{head}</div>
                        {divs}
                    </div>
                </>
            )

        let additionalButton = <button className="btn btn-danger" onClick={this.neuesProduktteil} >Unterrichtseinheit +</button>
        if (this.state.activeLektion.id===0){
            additionalButton=<div>Lektion speichern, schließen, wieder öffnen, erst dann können Unterrichtseinheiten hinzugefügt werden.</div>
        }


        return(

            <Modal 
              modalid="modalNeuesProduktDialog" 
              buttonid="modalNeuesProduktDialogButton" 
              body={navs}
              title={title}
              okButtonenabled={true} 
              okButtonClick={this.saveNeuesProdukt}
              okButtonTitle="Speichern"
              closeButtonTitle = "Abbrechen"
              modalExtraLarge={true}
              additionalButton={additionalButton}


               
           /> 
          )
    }

    modalNeueUnterrichtseinheit(){

        if (this.state.unterrichtseinheit===null) return null

        const _this = this

        function changePdfValue(id, dateiname){
            const unterrichtseinheit = _this.state.unterrichtseinheit
            unterrichtseinheit.pdf_id = id
            unterrichtseinheit.dateinamepdf = dateiname
            document.getElementById('fileInput').value= null;
            _this.setState({unterrichtseinheit, file1:null})
        }

        let dateinamepdf = null
        if (this.state.unterrichtseinheit.pdf_id > 0) dateinamepdf = this.state.unterrichtseinheit.dateinamepdf
    
        function pdfRow(pdf){           
            return(
                <button onClick={()=>changePdfValue(pdf.id, pdf.dateiname)} className="dropdown-item">{pdf.dateiname}</button>    
            )
        }

        const dropDownPdfs =(
            <>
                <button className="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown"  type="button" aria-expanded="false">
                {this.getLanguageString('$STR_0232')}
                </button>
                <ul className="dropdown-menu">
                {_this.state.pdfs.map(pdfRow)}                
                </ul>
            </>
        )

        function resetPdf(){
            const unterrichtseinheit = _this.state.unterrichtseinheit
            unterrichtseinheit.pdf_id = 0
            unterrichtseinheit.dateinamepdf = ""
            _this.setState({unterrichtseinheit})
        }

        let resetPdfButton=null
        if (this.state.unterrichtseinheit.pdf_id>0){
            resetPdfButton=<button className="btn-sm-round btn-info" onClick={resetPdf}><i className="material-icons"> close </i></button>
        }

        const body=(
            <>
                <div className="form-group">
                    <label ><strong>{this.getLanguageString('$STR_0233')}</strong></label>
                    <textarea className="form-control" rows={3}  name="lernziele" onChange={(e)=>changeUnterrichtseinheit(e)}  value={this.state.unterrichtseinheit.lernziele} />
                </div>     
                <div style={{display:'flex'}}>
                    <div className="form-group" style={{width:'70%'}}>
                        <label>PDF {this.state.unterrichtseinheit.dateinamepdf}</label>
                        <input className="invisible" type="file" accept="application/pdf" id="fileInput"   name="file1"  onChange={(e)=>changeUnterrichtseinheit(e)} />    

                        {dropDownPdfs}  {resetPdfButton}
                    </div>
                </div>
                
                <div className="form-group" style={{width:'30%'}}>
                <label>YouTube Video-ID</label>
                    <input className="form-control" type="text"  name="videourl" onChange={(e)=>changeUnterrichtseinheit(e)}  value={this.state.unterrichtseinheit.videourl} />
                </div>
                <div className="form-group" style={{width:'70%'}}>
                <label>{this.getLanguageString('$STR_0193')}</label>
                    <textarea className="form-control" type="text" rows={3} name="bemerkungen" onChange={(e)=>changeUnterrichtseinheit(e)}  value={this.state.unterrichtseinheit.bemerkungen} />
                </div>
            </>
        )

        let okButtonenabled = this.state.unterrichtseinheit.lernziele !== ""

        function changeUnterrichtseinheit(e){
            let unterrichtseinheit = _this.state.unterrichtseinheit

            if (e.target.name === "file1"){
                if (e.target.files[0] !== undefined){
                    _this.setState({file1:e.target.files[0]})
                }
                else{
                   
                   // document.getElementById('fileInput').value= null;
                }
            }

            _this.saveUE(e, unterrichtseinheit)
            _this.setState({unterrichtseinheit})
        }

        function saveUnterrichtseinheit(){
            axios.post('/api/unterrichtseinheiten', _this.state.unterrichtseinheit)
            .then(
                result=>{
                    if (result.data !==null){
                        const schueler_taeglicheLektion = _this.state.schueler_taeglicheLektion
                        schueler_taeglicheLektion.unterrichtseinheiten = result.data
                        _this.setState({schueler_taeglicheLektion})
                    }
                }
            )
        }

        let title = this.getLanguageString('$STR_0230')
        if (this.state.ueEditMode===1){
            title=this.getLanguageString('$STR_0236')
        }


        return(
            <Modal 
              modalid="modalNeueUnterrichtseinheitDialog" 
              buttonid="modalNeueUnterrichtseinheitDialogButton" 
              body={body}
              title={title}
              okButtonenabled={okButtonenabled} 
              okButtonClick={saveUnterrichtseinheit}
              okButtonTitle={this.getLanguageString('$STR_0093')}  
              closeButtonTitle = {this.getLanguageString('$STR_0184')}              
           /> 
          )
    }

    editUnterrichtseinheit(unterrichtseinheit){
        this.setState({unterrichtseinheit,ueEditMode:1}, function(){$('#modalNeueUnterrichtseinheitDialogButton').click()})

    }

    moveUnterrichtseinheit(ue){

        if (ue.rangfolge===1) return

        function moveObjectAtIndex(array, sourceIndex, destIndex) {
            var placeholder = {};
            // remove the object from its initial position and
            // plant the placeholder object in its place to
            // keep the array length constant
            var objectToMove = array.splice(sourceIndex, 1, placeholder)[0];
            // place the object in the desired position
            array.splice(destIndex, 0, objectToMove);
            // take out the temporary object
            array.splice(array.indexOf(placeholder), 1);
        }

        let schueler_taeglicheLektion = this.state.schueler_taeglicheLektion    
        let sourceIndex = schueler_taeglicheLektion.unterrichtseinheiten.indexOf(ue)
    
        moveObjectAtIndex(schueler_taeglicheLektion.unterrichtseinheiten, sourceIndex, sourceIndex-1)    
       
        let number = 1
        schueler_taeglicheLektion.unterrichtseinheiten.forEach(
            unterrichtseinheit=>{               
                unterrichtseinheit.rangfolge = number
                const sql=`UPDATE frc_unterrichtseinheiten SET rangfolge=${number} WHERE id=${unterrichtseinheit.id}`
                axios.post('/api/execcommonquery', {sql})
                number++
            }
        )
        this.getTaeglicheLektion(this.state.activeUser.id)

        
        

        
    }

    editAkkord(akkord){
        this.setState({akkord}, function(){$('#modalNeuerAkkordDialogButton').click()})

    }

    modalNeuerAkkordDialog(){

        const _this = this

        function changeAkkord(e){
            const akkord = _this.state.akkord
            if (e.target.name ==="name_de") akkord.name_de = e.target.value;
            if (e.target.name ==="name_en") akkord.name_en = e.target.value;
            if (e.target.name ==="bund_saite1") akkord.bund_saite1 = e.target.value;
            if (e.target.name ==="bund_saite2") akkord.bund_saite2 = e.target.value;
            if (e.target.name ==="bund_saite3") akkord.bund_saite3 = e.target.value;
            if (e.target.name ==="bund_saite4") akkord.bund_saite4 = e.target.value;
            if (e.target.name ==="bund_saite5") akkord.bund_saite5 = e.target.value;
            if (e.target.name ==="bund_saite6") akkord.bund_saite6 = e.target.value;
            if (e.target.name ==="finger_saite1") akkord.finger_saite1 = e.target.value;
            if (e.target.name ==="finger_saite2") akkord.finger_saite2 = e.target.value;
            if (e.target.name ==="finger_saite3") akkord.finger_saite3 = e.target.value;
            if (e.target.name ==="finger_saite4") akkord.finger_saite4 = e.target.value;
            if (e.target.name ==="finger_saite5") akkord.finger_saite5 = e.target.value;
            if (e.target.name ==="finger_saite6") akkord.finger_saite6 = e.target.value;
            if (e.target.name ==="barree") akkord.barree = Number(e.target.value);
            if (e.target.name ==="lage") akkord.lage = Number(e.target.value);
            if (e.target.name ==="ist_oeffentlich") {
                akkord.ist_oeffentlich = 0
                if (e.target.checked) akkord.ist_oeffentlich = 1;
            }
            
            _this.setState({akkord})
        }

        const body=(
            <div className="row">
                <div className="col-6">
                    <Akkord
                        akkord={this.state.akkord}
                        language={this.state.language}
                    />
                </div>
                <div className="col-6">
                    <font color="red"><b>{this.state.errortext}</b></font>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>name_de</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.name_de} name="name_de" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>name_en</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.name_en} name="name_en" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite1</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite1} name="bund_saite1" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite2</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite2} name="bund_saite2" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite3</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite3} name="bund_saite3" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite4</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite4} name="bund_saite4" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite5</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite5} name="bund_saite5" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>bund_saite6</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.bund_saite6} name="bund_saite6" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite1</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite1} name="finger_saite1" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite2</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite2} name="finger_saite2" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite3</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite3} name="finger_saite3" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite4</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite4} name="finger_saite4" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite5</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite5} name="finger_saite5" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>finger_saite6</td>
                                <td><input className="form-control" type="text" value={this.state.akkord.finger_saite6} name="finger_saite6" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>barree</td>
                                <td><input className="form-control" type="number" value={this.state.akkord.barree} name="barree" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td>lage</td>
                                <td><input className="form-control" type="number" value={this.state.akkord.lage} name="lage" onChange={(e)=>changeAkkord(e)} /></td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                <div className="form-check form-switch">
                                    <input id="flexSwitchCheckDefault" className="form-check-input" type="checkbox"  name="ist_oeffentlich" role="switch" onChange={(e)=>changeAkkord(e)} checked={this.state.akkord.ist_oeffentlich===1} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">ist öffentlich</label>
                                </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )

        
        let okButtonenabled =  (this.state.akkord.name_de !=="" && this.state.akkord.name_en !=="" )


       
    
        function saveAkkord(){
          
                axios.post('/api/akkorde', _this.state.akkord)
                .then(
                    result=>{
                        _this.getAkkorde()
                    }
                )

        }

        return(

            <Modal 
              modalid="modalNeuerAkkordDialog" 
              buttonid="modalNeuerAkkordDialogButton" 
              body={body}
              title="Neuer Akkord"
              okButtonenabled={okButtonenabled} 
              okButtonClick={saveAkkord}
              okButtonTitle="Speichern"
              closeButtonTitle = "Abbrechen"
               
           /> 
          )

        
    }

    modalMessageBoxDialog(){

        return(

            <Modal 
              modalid="modalMessageBoxDialog" 
              buttonid="modalMessageBoxDialogButton" 
              body={this.state.messageText}
              title={this.state.messageTitle}
              messagebox={true}
              okButtonenabled={true} 
               
           /> 
          )
    }

    modalDeleteUE(){

        const _this = this
        if (this.state.unterrichtseinheit===null) return null

        function deleteUE(){
            const sql=`DELETE FROM frc_unterrichtseinheiten WHERE id=${_this.state.unterrichtseinheit.id}`
            axios.post('/api/execcommonquery', {sql})
            .then(
                result=>{
                    _this.getTaeglicheLektion(_this.state.activeUser.id)
                }
            )
        }

        return(
            <Modal 
              modalid="modalDeleteUEDialog" 
              buttonid="modalDeleteUEDialogButton" 
              body={this.getLanguageString('$STR_0237')}
              title={this.getLanguageString('$STR_0237')}              
              okButtonenabled={true}  
              okButtonTitle="OK"
              closeButtonTitle={this.getLanguageString('$STR_0184')} 
              okButtonClick={deleteUE}
           /> 
          )
    }

    modalPdfDialog(){

        if (this.state.activeUnterrichtseinheit === null ) return null

      
        let body = null

        this.state.pdfs.forEach(
            pdf=>{
                 if (pdf.id === this.state.activeUnterrichtseinheit.pdf_id){

                    const src = `https://franciscoguitar.de/media/pdf/${pdf.id}.pdf`
                    console.log(src)
                    body = (
                        <div>
                            <iframe src={src} style={{width:'100%', minHeight:'700px'}}></iframe>
                        </div>
                    )
                }
            }
        )

        return(
            <Modal 
              modalid="modalPdfDialog" 
              buttonid="modalPdfDialogButton" 
              body={body}
              title={this.state.activeUnterrichtseinheit.thema}
              closeButtonTitle={this.getLanguageString('$STR_0249')} 
              closeButtonClick={()=>this.zeigeProdukt(this.state.activeProduct)}
              messagebox={true}
              modalStyle={{minWidth:'95%', minHeight:'95%'}}   
              databsbackdrop={true}                     
              
           /> 
          )
    }

    

    modalError(){
        return(
          <Modal 
            modalid="error" 
            buttonid="errorButton" 
            body={this.state.errortext}
            title="Fehler bei der Eingabe"
            messagebox={true}
            okButtonenabled={true}  
         /> 
        )
    }
    

    modalDatenschutz(){

        const body=(
            <div>
               <p><strong>Allgemeiner Hinweis und Pflichtinformationen</strong></p>
<p><strong>Benennung der verantwortlichen Stelle</strong></p>
<p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
<p><span id="s3-t-firma">Herbert Dapper</span><br/><span id="s3-t-strasse">Ringstraße 3</span><br/><span id="s3-t-plz">DE-78052</span> <span id="s3-t-ort">Villingen-Schwenningen</span></p><p></p>
<p>Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).</p>

<p><strong>Widerruf Ihrer Einwilligung zur Datenverarbeitung</strong></p>
<p>Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p>

<p><strong>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</strong></p>
<p>Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der folgende Link stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit: <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank">https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a>.</p>

<p><strong>Recht auf Datenübertragbarkeit</strong></p>
<p>Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p>

<p><strong>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</strong></p>
<p>Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum aufgeführten Kontaktmöglichkeiten an uns wenden.</p>

<p><strong>SSL- bzw. TLS-Verschlüsselung</strong></p>
<p>Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie über diese Website übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte Verbindung an der „https://“ Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.</p>

<p><strong>Kontaktformular</strong></p>
<p>Per Kontaktformular übermittelte Daten werden einschließlich Ihrer Kontaktdaten gespeichert, um Ihre Anfrage bearbeiten zu können oder um für Anschlussfragen bereitzustehen. Eine Weitergabe dieser Daten findet ohne Ihre Einwilligung nicht statt.</p>
<p>Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>
<p>Über das Kontaktformular übermittelte Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder keine Notwendigkeit der Datenspeicherung mehr besteht. Zwingende gesetzliche Bestimmungen - insbesondere Aufbewahrungsfristen - bleiben unberührt.</p>

<p><strong>YouTube</strong></p>
<p>Für Integration und Darstellung von Videoinhalten nutzt unsere Website Plugins von YouTube. Anbieter des Videoportals ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.</p>
<p>Bei Aufruf einer Seite mit integriertem YouTube-Plugin wird eine Verbindung zu den Servern von YouTube hergestellt. YouTube erfährt hierdurch, welche unserer Seiten Sie aufgerufen haben.</p>
<p>YouTube kann Ihr Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen, sollten Sie in Ihrem YouTube Konto eingeloggt sein. Durch vorheriges Ausloggen haben Sie die Möglichkeit, dies zu unterbinden.</p>
<p>Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.</p>
<p>Einzelheiten zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von YouTube unter: <a href="https://www.google.de/intl/de/policies/privacy">https://www.google.de/intl/de/policies/privacy</a>.</p>
        <p><small>Quelle: Datenschutz-Konfigurator von <a href="http://www.mein-datenschutzbeauftragter.de" target="_blank">mein-datenschutzbeauftragter.de</a></small></p>


                
                
                
              
    
            </div>
        )
    
        return(
    
            <Modal
                modalid="modalDatenschutzDialog"
                buttonid="modalDatenschutzDialogButton"   
                title="Datenschutzerklärung" 
                body={body} 
                messagebox={true}
                closeButtonTitle="OK"
                modalExtraLarge={true}
            />
        )
    }

   



    modalImpressum(){

        const body=(
            <div>   
                <p><span id="s3-t-firma">Herbert Dapper<br/></span><br/>
                <span id="s3-t-strasse">Ringstraße 3</span><br/>
                <span id="s3-t-plz">DE-78052</span> <span id="s3-t-ort">Villingen-Schwenningen</span><br/>   
                <span id="s3-t-email">Email: info@franciscoguitar.de</span>    </p>          
    
            </div>
        )
    
        return(
    
            <Modal
                modalid="modalImpressumDialog"
                buttonid="modalImpressumDialogButton"   
                title="Impressum" 
                body={body} 
                messagebox={true}
                closeButtonTitle="OK"
            />
        )
    }

    einkauf(){
            this.setState({einkauf_schritt:0}, ()=>{this.toggleNav(); $('#modalEinkaufswagenButton').click()})
    }
        
       

    navBar(){

        var flagDE='flag_de.jpg';
        if (this.state.language==='de')	{
            flagDE='flag_de_.jpg'; 

        }

        var flagEN='flag_en.jpg';
        if (this.state.language==='en')	{
            flagEN='flag_en_.jpg';
        }

        var flagES='flag_es.jpg';
        if (this.state.language==='es')	{
            flagES='flag_es_.jpg';
        }

        var flagIT='flag_it.jpg';
        if (this.state.language==='it')	{
            flagIT='flag_it_.jpg';
        }

        var flagFR='flag_fr.jpg';
        if (this.state.language==='fr')	{
            flagFR='flag_fr_.jpg';
        }

        var flagPT='flag_pt.jpg';
        if (this.state.language==='pt')	{
           flagPT='flag_pt_.jpg';
        }

        const _this = this        

     
        var src=`/assets/images/${flagDE}`
        var flagImageDE=<a href="#" onClick={()=>this.setState({language:'de'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>
        src=`/assets/images/${flagEN}`
        var flagImageEN=<a href="#" onClick={()=>this.setState({language:'en'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>
        src=`/assets/images/${flagES}`
        var flagImageES=<a href="#" onClick={()=>this.setState({language:'es'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>
        src=`/assets/images/${flagIT}`
        var flagImageIT=<a href="#" onClick={()=>this.setState({language:'it'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>
        src=`/assets/images/${flagFR}`
        var flagImageFR=<a href="#" onClick={()=>this.setState({language:'fr'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>
        src=`/assets/images/${flagPT}`
        var flagImagePT=<a href="#" onClick={()=>this.setState({language:'pt'}, function(){_this.toggleNav()})}><img src={src} border={0} /></a>   
        
       

        let li_einkaufswagen = null
        if (this.state.einkaufswagen.length >0){
            li_einkaufswagen=(

                <li className="nav-item">
                    <button className="nav-link link text-warning display-4" onClick={this.einkauf}  ><i className="material-icons">shopping_cart</i> <sup>{this.state.einkaufswagen.length}</sup></button>
                </li>
            )
           
        }

        let unterrichtsMenu =   
            <li className="nav-item">
                <a className="nav-link link text-warning nav-font" onClick={()=>this.setState({activePage:'unterrichtDiv', unterrichtgeklickt:this.state.unterrichtgeklickt+1}, function(){_this.toggleNav()})} href="#">{this.getLanguageString('$STR_0004').toUpperCase()}</a>
            </li>    
        if (this.state.unterrichtgeklickt > 0){
            unterrichtsMenu=(  
                <li id="unterrichtsmenu" className="nav-item">
                    <a className="nav-link link dropdown-toggle text-warning nav-font" onClick={()=>{$('#unterrichtsMenuButton').click();this.toggleNav()}} href="#">{this.getLanguageString('$STR_0004').toUpperCase()}</a>
                </li>    

            )
        }

        let gitarrenSchule_li =(
               <li className="nav-item">
                                <a className="nav-link link text-warning nav-font" onClick={()=>this.setState({activePage:'gitarrenschule'}, function(){_this.toggleNav()})} href="#">{this.getLanguageString('$STR_0034').toUpperCase()}</a>
                            </li>
        )
        gitarrenSchule_li = null //wegen Aufgabe der Schule, kommt nicht gut im Web, zu amateurhaft!


        let navLernvideos=null
        if (this.state.showLernvideos){

            navLernvideos= 
            <>
                <li className="nav-item">
                    <a className="nav-link link text-warning nav-font" onClick={this.zeigeLernvideos} href="#">{this.getLanguageString('$STR_0128').toUpperCase()}</a>
                </li>
            </>            
            
        }
        
   
        return(

            <section  className="menu cid-r8Q0WEje6z noprint" once="menu" id="menu2-4" style={{position:'relative'}}>

                <nav className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
                        <div className="navbar-brand">
                        <span>
                            <a href="#" onClick={()=>this.setState({activePage:'home'})}>
                                <img src="/assets/images/title.png" alt="Francisco" style={{height: '4.6rem'}} />
                            </a>
                        </span>
                        <span className="navbar-caption-wrap">
                        
                        </span>
                    </div>
                    <button className="navbar-toggler" id="toggler"  type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <div className="hamburger">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                    <div  className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true">
                            <li className="nav-item">
                                <a className="nav-link link text-warning nav-font" onClick={()=>this.setState({activePage:'about'}, function(){_this.toggleNav()})} href="#">{this.getLanguageString('$STR_0002').toUpperCase()}</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link link text-warning nav-font" onClick={()=>this.setState({activePage:'music'}, function(){_this.toggleNav()})} href="#">{this.getLanguageString('$STR_0269').toUpperCase()}</a>
                            </li>
                            {navLernvideos}
                            {gitarrenSchule_li}
                            {this.anmeldeMenu()}                             
                        </ul>                    
                        {flagImageDE}
                        {flagImageEN}
                        {flagImageES}
                        {flagImageFR}
                        {flagImageIT}
                        {flagImagePT}
                    <div>
                    </div>
                </div>
                </nav>
          
            </section>
            )
    }

     navbar2(){
        return(
            
            <div style={{backgroundColor:'black'}}>

            <nav  className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg" style={{backgroundColor:'black'}}>
                <a className="navbar-brand" href="/">
                    <img src="/assets/images/title.png" alt="Francisco" style={{height: '4.6rem'}} />
                </a>
            </nav></div>
        )
    }


    modalEinkaufswagen(){

   
        if (this.state.einkaufswagen===undefined) return null

        const _this = this

        function emailExistiert(){
            let result = false
            _this.state.alleBenutzerRegistriert.forEach(
                (bn)=>{

                    if (bn.email === _this.state.registeremail){
                      result = true
                      if (_this.state.activeUser===null || _this.state.activeUser===undefined){
                        axios.get('/api/benutzer/byemail/' + _this.state.registeremail)
                        .then(
                            result=>{
                                if (result.data !== null){
                                    _this.setState({activeUser:result.data, isLoggedIn:true})
                                }
                            }
                        )
                      }
                    }
                }
            )
            return result
        }

    
        function wagenRow(produkt){

            function splice(){
                let einkaufswagen = _this.state.einkaufswagen
                const index = einkaufswagen.indexOf(produkt);
                if (index > -1) { // only splice array when item is found
                    einkaufswagen.splice(index, 1); // 2nd parameter means remove one item only
                }
                _this.setState({einkaufswagen})
                if (einkaufswagen.length===0) $('#modalEinkaufswagenButton').click()
            }

            const src=`/media/albumthumbs/${produkt.cover_image}`

            return(

                <tr>
                    <td width={160}>
                        <img src={src} className="img-fluid card" alt={produkt.thema} />   
                    </td>
                    <td style={{minWidth:'300px', padding:'20px'}}>
                      
                            <strong>{stringToHML(produkt.thema)}</strong>
                            
                       
                    </td>
                    <td>
                        <button className="btn btn-secondary"  style={{width:'35px', borderRadius:'15px'}} onClick={splice}  ><i className="material-icons"> delete </i></button>
                    </td>
                    <td width={150} style={{textAlign:'right'}}>
                        {produkt.preis.toFixed(2)} €
                    </td>
                </tr>
            )
        }

       

        function summe(){
            summe = 0;
            _this.state.einkaufswagen.forEach(
                (produkt)=>{
                    summe = summe + produkt.preis
                }
            )
            return summe
        }

     
        let btnZurKasse= <button style={{marginTop:'15px'}} onClick={()=>this.setState({einkauf_schritt:1})} className="btn btn-primary">{this.getLanguageString('$STR_0256')}</button>
        if (this.state.einkaufswagen.length ===0)btnZurKasse= <button disabled  style={{marginTop:'15px'}}  className="btn btn-primary">{this.getLanguageString('$STR_0256')}</button>

        let titelSumme=`${this.getLanguageString('$STR_0258').replace('x', this.state.einkaufswagen.length)}`


        let body=(
            <div>
                <div>
                    
                    <div className="table-responsive">                   
                        <table className="table table-striped">
                            <tbody>
                                {this.state.einkaufswagen.map(wagenRow)}  
                            </tbody>
                        </table> 
                    </div>
                    <hr/>
                    <div style={{textAlign:'right'}}>
                        <strong>{titelSumme} {summe().toFixed(2)} €</strong>
                        {btnZurKasse}
                    </div>
                </div>
            </div>
        )


        let title=this.getLanguageString('$STR_0257')

        if (this.state.einkauf_schritt===1){          
            title = this.getLanguageString('$STR_0260')

            let divRegistrieren=null
            if ( this.state.registeremail !=="" &&  emailExistiert(this.state.registeremail)===false){
                divRegistrieren=(
                    <div style={{marginTop:'20px'}}>
                        <div>{stringToHML(this.getLanguageString('$STR_0262'))}</div>
                           <button className="btn btn-secondary" onClick={this.register}>{this.getLanguageString('$STR_0238')}</button>
                       

                    </div>
                )
            }

            let inputName = <strong style={{marginLeft:'20px'}}>{this.state.registername}</strong>
            let inputEmail = <strong style={{marginLeft:'20px'}}>{this.state.registeremail}</strong>
            if (this.state.isLoggedIn===false){
                inputName=<input type="text" autoComplete="off" value={this.state.registername} onChange={(e)=>this.setState({registername:e.target.value})} className="form-control" placeholder={this.getLanguageString('$STR_0241')}/>        
                inputEmail= <input type="email" autoComplete="off" value={this.state.registeremail} onChange={(e)=>this.setState({registeremail:e.target.value})} className="form-control" placeholder={this.getLanguageString('$STR_0141')}/>
            }

            let divInputBenutzername = null

            if (this.state.registeremail!=="" &&   emailExistiert(this.state.registeremail)===false){
                divInputBenutzername = (
                    <div className="form-group" style={{marginTop:'20px'}}>
                    <label>{this.getLanguageString('$STR_0241')}</label>
                    {inputName}
                 </div>
                )
            }

            let divKaufen = null




            if (emailExistiert(this.state.registeremail)){


                if (!window.ApplePaySession) {
	                console.log('This device does not support Apple Pay');
	            }
               

                summe = 0;
                _this.state.einkaufswagen.forEach(
                    (produkt)=>{
                        summe = summe + produkt.preis
                    }
                )
                
                let locale = `${this.state.language}-${this.state.language.toUpperCase()}`
                if (this.state.language==="en") locale="en-US"

              
                
               
                let applePayButton = 
                    <ApplePayButton
                                locale={locale}
                            />

                divKaufen =
             
                    <div id="payment-options"  style={{marginTop:'25px'}}>  
                           
                        <div style={{height:'15px'}}    />            
                        
                        <PayPal                        
                            value={0.25}
                            locale={this.state.language}
                            produkteZuordnen={(details) => this.produkteZuordnen(details)}
                            setPayPalError={()=>window.alert(this.getLanguageString('$STR_0265'))}
                        />
                        
                 
                    </div>
            }
       
             body=(
                <>
                <div>
                        <h3>{this.getLanguageString('$STR_0263')}</h3>

                        <div className="form-group>">
                            <label>{this.getLanguageString('$STR_0141')}</label>
                            {inputEmail}                            
                        </div>

                       {divInputBenutzername}

                       {divRegistrieren}

                       {divKaufen}                    
                </div>      
              
                </>
            )
        }

        
        let backBtn = <button style={{marginTop:'15px'}} onClick={()=>this.setState({einkauf_schritt:0})} className="btn btn-primary">{this.getLanguageString('$STR_0259')}</button>
        if (this.state.einkauf_schritt===0) backBtn = null

        let closeButtonTitle = this.getLanguageString('$STR_0184')
 
        if (this.state.einkauf_schritt===2){
            backBtn = null
            title = this.getLanguageString('$STR_0261')
            closeButtonTitle=this.getLanguageString('$STR_0249')
            body=(
                <div>{stringToHML(this.getLanguageString('$STR_0264'))}</div>
            )
        }


    
        return(

            <Modal 
                modalid="modalEinkaufswagen"
                buttonid="modalEinkaufswagenButton"   
                title={title}
                body={body} 
                modalLarge={true}
                messagebox={true}
                additionalButton={backBtn}
                closeButtonTitle={closeButtonTitle}
            />
        )
    }

    produkteZuordnen(details){
        console.log(details)

        let benutzerKaeufe=[]

        this.state.einkaufswagen.forEach(
            produkt =>{
                const benutzerKauf ={
                    id:0,
                    benutzer_id:this.state.activeUser.id,
                    lektion_id:produkt.id,
                    preis:produkt.preis,
                    datum:new Date(),
                    transaktions_nr:details.id,
                    payer_email_address:details.payer.email_address,
                    payer_country_code:details.payer.address.country_code,
                    payer_given_name: details.payer.name.given_name,
                    payer_surname:details.payer.name.surname,

                }
                benutzerKaeufe.push(benutzerKauf)           
            }
        )
      
        axios.post('/api/benutzerkaeufe', benutzerKaeufe)
        .then(
            result =>{                
                let activeUser = this.state.activeUser
                activeUser.benutzerKaeufe = result.data
                this.setState({einkauf_schritt:2, benutzerkaeufe:result.data,activeUser, einkaufswagen:[],})
                console.log(result.data)
            }
            
        )



        
    }

    showModalLoginDoalog(){
   
        if (this.navBarHeight() > 50){
            $('#toggler').click()
        }
        $('#modalLogindialogButton').click()
    }

    modalLogindialog(){

        

        let okButton = <button  className="btn btn-form btn-primary display-4" onClick={this.checkLogin}  >{this.getLanguageString('$STR_0031')}</button>
        if (this.state.email === "" || this.state.passwort==="" ){
            okButton = <button  className="btn btn-form btn-primary display-4" disabled   >{this.getLanguageString('$STR_0031')}</button>
        }

        let body = this.loginContent()
        if (this.state.passwortvergessen){
            body= this.passwortvergessenContent()
        }
        if (this.state.registrieren){
            body= this.registrierenContent()
        }
     
        return (
            <Modal 
                modalid="modalLogindialog"
                buttonid="modalLogindialogButton"   
                title={this.getLanguageString('$STR_0066')} 
                body={body} 
                okButton={okButton}
                showBottomButtons={false}
            />
        )
    }

    aboLoeschen(){
        const array={
            sql:`DELETE FROM frc_unterricht_abos WHERE id=${this.state.activeAbo.id}`
        }

        const _this = this


        axios.post('/api/execcommonquery', array)
        .then(
            result=>{
                
                   this.setState({activeAbo:null}, function(){_this.getSchueler()})
                /*   $('.modal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass( "modal-open" );    */  

               
            }
        )
    }

    deleteAboDialog(){

        if (this.state.activeAbo===null) return null

        const msg=`Abonnement ${this.state.activeAbo.thema_de} löschen?`

        return(
            <Modal 
            modalid="modalDeleteAboDialog"
            buttonid="modalDeleteAboDialogDialogButton"   
            title="Abomnnement löschen"
            body={msg} 
            okButtonClick={this.aboLoeschen}
            okButtonTitle="OK"
            closeButtonTitle={this.getLanguageString('$STR_0184')}
            />
        )

    }

    deleteSchuelerDialog(){

        if (this.state.activeSchueler===null) return null

        const msg=`Schüler/in ${this.state.activeSchueler.name} löschen?`

        return(
            <Modal 
            modalid="modalDeleteSchuelerDialog"
            buttonid="modalDeleteSchuelerDialogButton"   
            title="Schüler/in löschen"
            body={msg} 
            okButtonClick={this.schuelerLoeschen}
            okButtonTitle="OK"
            closeButtonTitle={this.getLanguageString('$STR_0184')}
            />
        )
    }

    footer(){
            let year = (new Date()).getFullYear();
            let copyright = `© ${year} FRANCISCOGUITAR.DE`
            let version = require("../../package.json").version
            let datum = require("../../package.json").datum
            let serverversion = null
            if (this.state.server !==null){
                serverversion = this.state.server.version
            }
    

            return(

            <section className="cid-r8R9ZFfxoE noprint" id="footer2-b">
            
                <div className="container text-center">           
                
                    <div className="row justify-content-center">
                        <ul className="foot-menu">                          
                            
                            <li className="">
                                <a href="#" onClick={()=>$('#modalImpressumDialogButton').click()} className="text-warning">
                                {this.getLanguageString('$STR_0008').toUpperCase()}
                                </a>
                            </li><li className="">
                                <a href="#" onClick={()=>$('#modalDatenschutzDialogButton').click()} className="text-warning">
                                {this.getLanguageString('$STR_0065').toUpperCase()}
                                </a>
                                <div className="rhombus"></div>
                            </li>
                            <li className="">
                                <a href="#" onClick={()=>this.setState({activePage:'contact'})} className="text-warning">
                                {this.getLanguageString('$STR_0006').toUpperCase()}
                                </a>
                                <div className="rhombus"></div>
                            </li>
                        </ul>
                    </div>                
                
                    <div className="row">
                       <div  className="text-primary">{copyright} {version}.{datum} {serverversion}</div> 
                       
                    </div>
                
                
                    
                </div>
            </section>

        )
    }

    aboutContent(){



        const images=[

            {
                src:"/assets/images/michaela_.jpg",
                title:this.getLanguageString('$STR_0198'),
                className:'w-full rounded'
            }       ,   

            {
                src:"/assets/images/juanherbert1_.png",
                title:this.getLanguageString('$STR_0064'),
                className:'w-full rounded',   
                
            },
            {
                src:"/assets/images/juan-herbert-benahaviz_.png",
                alt:this.getLanguageString('$STR_0064'),
                className:'w-full rounded',   
            },
            {
                src:"/assets/images/cordoba_.jpg",
                title:this.getLanguageString('$STR_0039'),
                className:'w-full rounded',    
            },
            {
                src:"/assets/images/manolo_.jpg",
                title:this.getLanguageString('$STR_0040'),
                className:'w-full rounded',    
            },
            {
                src:"/assets/images/manolofrancisco_.jpg",
                title:this.getLanguageString('$STR_0041'),
                className:'w-full rounded',   
            },
            {
                src:"/assets/images/manolosign_.jpg",
                title:this.getLanguageString('$STR_0042'),
                className:'w-full rounded',  
            },
            {
                src:"/assets/images/tomatito_.jpg",
                title:this.getLanguageString('$STR_0043'),
                className:'w-full rounded'
            },
            {
                src:"/assets/images/gerardo_.jpg",
                title:this.getLanguageString('$STR_0044'),
                className:'w-full rounded'
            },
            {
                src:"/assets/images/juanronda_.jpg",
                title:this.getLanguageString('$STR_0045'),
                className:'w-full rounded'
            },
            {
                src:"/assets/images/juansign_.jpg",
                title:this.getLanguageString('$STR_0046'),
                className:'w-full rounded'
            },
            {
                src:"/assets/images/cd8_.jpg",
                title:this.getLanguageString('$STR_0055'),
                className:'w-full rounded'
            },
        ]

       const slideshow=(
            <SlideshowLightbox style={{width:'100%'}}
                className='container grid grid-cols-3 gap-2 mx-auto' 
                showThumbnails={true} 
                open={this.state.slideShowOpen}
                onClose={()=>this.setState({slideShowOpen: false})}
                images={images} 
                captionStyle={{color: "silver"}}>
            </SlideshowLightbox> 
        )

        const buttonSlideShow = <button style={{width:'90%'}} className="btn btn-primary" onClick={()=>this.setState({slideShowOpen:true})}>Open SlideShow</button>


        return(

            <>

            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/sanchis.png)'}}>
                <div className="container text-center" data-stellar-background-ratio=".3" >
                    <div className="row slider-wrapper">
                        <div className="col-md-12">
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>    
                                <div className="row justify-content-center pt-5" >    
    
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 row-item" style={{padding:'20px'}}> 
                                        <img src="/assets/images/guitar.png"/>                        
                                        <h4 className="mbr-fonts-style mbr-card-title" >{this.getLanguageString('$STR_0011')}</h4>
                                        <p className="normal-font">{this.getLanguageString('$STR_0014')}{this.getLanguageString('$STR_0015')}</p>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 row-item"> 
                                        <img  style={{margin:'auto'}} className="card" src="/assets/images/studio1.jpg" width="100%"/>  
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 row-item" style={{padding:'20px'}}> 
                                        <img src="/assets/images/bailarina.png"/> 
                                        <h4 className="mbr-fonts-style mbr-card-title">{this.getLanguageString('$STR_0012')}</h4>
                                        <p className="normal-font">{this.getLanguageString('$STR_0016')} {this.getLanguageString('$STR_0017')}</p>  
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 row-item" style={{marginTop:'20px'}}> 
                                         <img style={{margin:'auto'}} className="card" src="/assets/images/studio2.jpg" width="100%"/>  
                                    </div>                                                      
                                </div>                                 
                            </div>
                        </div>
                    </div> 
                </div>   
            </section>          

                     
                  <div className="row">
                        <div className="col-12" >
                            {buttonSlideShow}
                            {slideshow}
                        </div>
                </div>
               
            </>
        )
    }

    gitarrenschuleContent(){


        return(
             <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background " id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about.png)'}}>
     
                <div className="container text-center showin" data-stellar-background-ratio=".5" style={{marginTop:'55px'}}>
                    <div className="row">            
                            
                        <div className="col-sm-12 col-md-6 slider-text  slider-text-two">                        
                            <div style={{textAlign:'left', backgroundColor:'white', padding:'10px'}}>
                                <h5>{this.getLanguageString('$STR_0163')}</h5>
                                {this.getLanguageString('$STR_0164')}                   
                                <ul className="nomargin" style={{textAlign:'left'}} >
                                <li>{this.getLanguageString('$STR_0165')}</li>
                                <li>{this.getLanguageString('$STR_0166')}</li>
                                <li>{this.getLanguageString('$STR_0167')}</li> 
                                </ul>

                                <p>{this.getLanguageString('$STR_0168')}</p>
                                <p>{this.getLanguageString('$STR_0169')}</p>
                                <p>{this.getLanguageString('$STR_0170')}</p>  
                            </div>
                        </div>
                         
                        <div className="col-sm-12 col-md-6 slider-text  slider-text-two">                        
                            <div style={{textAlign:'left', backgroundColor:'white', padding:'10px'}}>
                                <h5>{this.getLanguageString('$STR_0179')}</h5>                      
                            
                                <ul style={{textAlign:'left'}}  className="nomargin">
                                <li>{this.getLanguageString('$STR_0171')}</li>
                                <li>{this.getLanguageString('$STR_0172')}</li>
                                <li>{this.getLanguageString('$STR_0173')}</li>
                                <li>{this.getLanguageString('$STR_0174')}</li>
                                <li>{this.getLanguageString('$STR_0175')}</li>
                                <li>{this.getLanguageString('$STR_0176')}</li>
                                </ul>
                                
                                <p>{this.getLanguageString('$STR_0177')}</p>
                                <p>{this.getLanguageString('$STR_0178')}</p>
                            </div>   
                            <p style={{marginTop:'35px'}}><a className="btn btn-form btn-primary display-4" href="#" onClick={this.neueUnterrichtsanfrage}>{this.getLanguageString('$STR_0122')}</a></p>
         
                        </div>
                    </div>
                 
                </div>        
               
               
            </section>
        )

       
    }




    homeContent(){

        let link1 = `https://www.eventpeppers.com/de/goto-profile/epp655787675/iw3`
        let link2 = `https://www.eventpeppers.com/de/profile/epp655787675/img-wid/3/w270/event-idee.jpeg`

        let eventpepperslink=<a href={link1} target="_blank"><img src={link2} alt="Event Idee" title="Francisco bei eventpeppers"  /></a>

       
        let divLernvideos=null
        if (this.state.showLernvideos){
            divLernvideos=(
                <div className="ccol-sm-12 col-md-6 col-lg-6 col-xl-4 row-item">                        
                <img src="/assets/images/sheetmusic.png" />                          
                    <h3 className="styled">{this.getLanguageString('$STR_0128')}</h3>
                    <div className="separator"></div>
                    <p className="normal-font">{this.getLanguageString('')}</p>                    
                    <a className="btn btn-primary normal-font" href="#" onClick={this.zeigeLernvideos} >{this.getLanguageString('$STR_0128')}</a>
            </div>
            )
        }


        return(
            <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/sanchis.png)'}}>
                <div className="container text-center" data-stellar-background-ratio=".3" >
                    <div className="row slider-wrapper">
                        <div className="col-md-12">
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>    
                                <div className="row justify-content-center pt-5" >       
                                    <div className="col-12 row-item"> 
                                                            
                                            <img   src="/assets/images/herbertgitarresw.png" style={{width:'100%', margin:'auto'}} className="card"/>                          
                                            <h1 className="styled" style={{marginTop:'25px'}}>Herbert »Francisco« Dapper</h1>
                                            <div className="separator"></div>
                                            <p className="normal-font">{this.getLanguageString('$STR_0276')}</p>
                                            <a className="btn btn-primary normal-font" href="#" onClick={()=>this.setState({activePage:'music'})} >{this.getLanguageString('$STR_0269')} »FRANCISCO«</a>
                                    </div>                                
                                </div>                            
                                    <div className="row justify-content-center pt-5" >    
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 row-item">   
                                            <img src="/assets/images/concert.png" width="400" height="200"/>                               
                                                <h3 className="styled">{this.getLanguageString('$STR_0099')}</h3>
                                                <div className="separator"></div>
                                                <p className="normal-font">{this.getLanguageString('$STR_0100')}</p>
                                                <a className="btn btn-primary normal-font" href="#"  onClick={()=>this.setState({activePage:'contact'})} >{this.getLanguageString('$STR_0098')}</a>
                                        </div>
                                        {divLernvideos}                                
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>   
            </section>
        )
    
    }



    setAbo(abo){
        const _this = this
        this.setState({activeAbo:null}, function(){_this.setState({activeAbo:abo}, function(){_this.getLektionen(abo.id)})})

    }

    changeAkkordeIds(e){
        let sql= `DELETE FROM frc_benutzer_akkorde WHERE akkord_id=${e.target.value} AND benutzer_id=${this.state.activeUser.id}`
        if (e.target.checked){
             sql= `INSERT INTO frc_benutzer_akkorde (akkord_id, benutzer_id) VALUES (${e.target.value}, ${this.state.activeUser.id})`
        }
        axios.post('/api/execcommonquery', {sql})
        .then(
            result=>{
                this.getBenutzerAkkorde(this.state.activeUser.id)
            }
        )
    }

    neuerAkkord(){
        this.setState({
            akkord:{
                id:0,
                name_de:'Neu',
                name_en:'',
                bund_saite1:'',
                bund_saite2:'',
                bund_saite3:'',
                bund_saite4:'',
                bund_saite5:'',
                bund_saite6:'',
                finger_saite1:'',
                finger_saite2:'',
                finger_saite3:'',
                finger_saite4:'',
                finger_saite5:'',
                finger_saite6:'',
                barree:0,
                lage:1,
                ist_oeffentlich:1
            }
        }, function(){$('#modalNeuerAkkordDialogButton').click()})
    }

    neuesProdukt(){
        //abo_id -10 alle  Produkte zum Verkauf

        let activeLektion = {
            id:0,
            abo_id:1,
            unterrichtszeit:'',
            lfdnr:0,
            bezahlt:0,
            ist_abgeschlossen:0,
            thema:'Neues Produkt',
            beschreibung_de:'',
            beschreibung_en:'',
            beschreibung_es:'',
            beschreibung_fr:'',
            beschreibung_it:'',
            beschreibung_pt:'',
            stilrichtung:'Alegría',
            stilrichtung2:'Alegría',
            ist_oeffentlich:0,
            preis:0,
            cover_image:'',
            videourl:'',
            video_ab_sec:0,
            video_dauer:0,
            standardcover:0,
            ist_technische_uebung:0,
            suchbegriffe:'',
            unterrichtseinheiten:[]
        }
        this.setState({activeLektion}, ()=>$('#modalNeuesProduktDialogButton').click())

 
                
    }

    addTaeglicheUebungAusListe(){

    }

    addTaeglicheUebung(){

        let rangfolge=1
        if (this.state.schueler_taeglicheLektion.unterrichtseinheiten.length > 0){
            rangfolge=this.state.schueler_taeglicheLektion.unterrichtseinheiten.length + 1
        }

        this.setState({
            unterrichtseinheit:{
                id:0,
                lektion_id:this.state.schueler_taeglicheLektion.id,
                thema:this.getLanguageString('$STR_0052'),
                bemerkungen:'',
                videourl:'',
                pdf_id:0,
                dateinamepdf:'',
                rangfolge,
                ist_oeffentlich:0,
                stilrichtung:'',
                lernziele:'',
                video_ab_sec:0,
                video_dauer:0
            },
            file1:null,
            ueEditMode:0
        }, function(){$('#modalNeueUnterrichtseinheitDialogButton').click()})
    }

    getContent(){

        var content = <div/>
        if (this.state.activePage === "showProduct" || this.state.activePage==="schuelerKauf") content= this.modalZeigeProduktDialog()
        if (this.state.activePage === "home") content = this.homeContent()
        if (this.state.activePage === "about") content = this.aboutContent()
        if (this.state.activePage === "gitarrenschule") content = this.gitarrenschuleContent()
        if (this.state.activePage === "akkorde") content = this.akkordeContent()
        if (this.state.activePage==="unterrichtDiv")content = this.unterrichtDiv()
        if (this.state.activePage === "produktlektionen") content =  this.produktlektionenContent()
        if (this.state.activePage === "meineAbos"  &&  this.state.activeUser!== null && this.state.activeUser.ist_admin===0)  content= (
            <Schueler
                getString={this.getLanguageString}
                schueler_lektionen={this.state.schueler_lektionen}
                schuelerTaeglicheLektion={this.state.schueler_taeglicheLektion}
                onShowActiveAbo={()=>$('#modalActiveSchuelerAboDialogButton').click()}
                onShowAngebotAbo={()=>$('#modalAngebotSchuelerAboDialogButton').click()}
                neueUnterrichtsanfrage={this.neueUnterrichtsanfrage}
                schuelerAbos={this.state.schuelerAbos}  
                activeSchuelerAbo={this.state.activeSchuelerAbo}
                angebotSchuelerAbo={this.state.angebotSchuelerAbo}   
                schuelerPage={this.state.schuelerPage}
                setSchuelerPage={(schuelerPage)=>this.setState({schuelerPage})}
                accountContent={this.accountContent()}
                benutzer_akkorde = {this.state.benutzer_akkorde}
                language={this.state.language}
                setAkkordePage={()=>this.setState({activePage:'akkorde'})}
                addTaeglicheUebung={this.addTaeglicheUebung}
                addTaeglicheUebungAusListe={this.addTaeglicheUebungAusListe}   
                editUnterrichtseinheit={this.editUnterrichtseinheit}  
                moveUnterrichtseinheit={this.moveUnterrichtseinheit}       
                deleteUnterrichtseinheit={this.deleteUnterrichtseinheit}    
                benutzerKaeufe={this.state.benutzerKaeufe}
                produkt_lektionen={this.state.produkt_lektionen}
                zeigeProdukt={this.zeigeProdukt}
                gekauft={(produkt)=>this.gekauft(produkt)}
                inDenEinkaufswagen={this.inDenEinkaufswagen}
            />            
        )
        if (this.state.activePage === "account") content= this.accountContent();
        if (this.state.activePage === "passwortvergessen") content= this.passwortvergessenContent();
        if (this.state.activePage === "music") content= this.musicContent();
        if (this.state.activePage === "contact") content= this.contactContent();
       
        if (this.state.activePage === "admin") content= (
            <Admin
                getString={this.getLanguageString}
                schuelerFilter={this.state.schuelerFilter}
                filteredSchueler={this.state.filteredSchueler}
                setSchuelerFilter={this.setSchuelerFilter}
                activeSchueler={this.state.activeSchueler}
                onSchuelerClick={(schueler)=>this.setState({activeSchueler:schueler, activeAbo:null})}
                activeAbo={this.state.activeAbo}
                onAboClick={(abo)=>this.setAbo(abo)}
                language={this.state.language}
                adminPage={this.state.adminPage}
                setAdminPage={(adminPage)=>this.setState({adminPage})}
                gespeichert={this.state.gespeichert}
                changeSchuelerData={(e)=>this.changeSchuelerData(e)}
                nav_abo_modus={this.state.nav_abo_modus}
                setNavAboModus={(modus)=>this.setState({nav_abo_modus:modus})}
                saveSchueler={this.saveSchueler}
                neuerSchueler={this.neuerSchueler}
                changeSchuelerStatus={(status)=>{this.changeSchuelerStatus(status)}}
                deleteSchueler={()=>$('#modalDeleteSchuelerDialogButton').click()}
                kursthemen={this.state.kursthemen}
                setKursthemaid={(value)=>this.setKursthemaid(value)}
                unterrichtsorte={this.state.unterrichtsorte}
                setUnterrichtsort={(value)=>this.setUnterrichtsort(value)}
                setAltersgruppe={(value)=>this.setAltersgruppe(value)}
                setLektionsdauer={(value)=>this.setLektionsdauer(value)}
                changeAbo={(e)=>this.changeAbo(e)}   
                lektionenpreise={this.state.lektionenpreise}     
                setAboStatus={(value)=>this.setAboStatus(value)}      
                saveAbo={(value)=>this.saveAbo(value)} 
                aboLoeschen={()=>$('#modalDeleteAboDialogDialogButton').click()} 
                neuesAbo={this.neuesAbo}
                lektionen={this.state.lektionen}
                editLektion={this.editLektion}
                aboangebotsenden={this.aboangebotsenden}
                this={this}
                aktiveAbos={this.state.aktiveAbos}
                onNeuerAkkordClick={()=>$('#modalNeuerAkkordDialogButton').click()}
                onNeuesProduktClick={this.neuesProdukt}   
                zeigeProdukte={()=>this.setState({activePage: 'produktlektionen'})}
            />
        )
        if (this.state.activePage==="unterrichtsanfrage") content = (
                <Unterrichtsanfrage
                getString={this.getLanguageString}
                language={this.state.language}
                kursthemen={this.state.kursthemen}
                activeAbo={this.state.activeAbo}   
                changeAbo={this.changeAbo}   
                setKursthemaid={(value)=>this.setKursthemaid(value)}    
                unterrichtsorte={this.state.unterrichtsorte}
                setUnterrichtsort={(value)=>this.setUnterrichtsort(value)} 
                setAltersgruppe={(value)=>this.setAltersgruppe(value)}
                setLektionsdauer={(value)=>this.setLektionsdauer(value)}
                lektionenpreise={this.state.lektionenpreise}
                setAnzahlstunden = {this.setAnzahlstunden}
                activeSchueler={this.state.activeSchueler}
                changeSchuelerData={this.changeSchuelerData}
                sendeUnterrichtsanfrage={(abo,schueler)=>this.sendeUnterrichtsanfrage(abo,schueler)}
            />
        )
        
        if (this.state.activePage === "dankeFuerUnterrichtBestellung") content = (
                <div className="container text-center" data-stellar-background-ratio=".5">
                    <div className="row slider-wrapper">
                        <div className="col-md-12" >
                            <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124'}}>    
                                <div className="row justify-content-center pt-5">                                    
                                
                                <h3>{this.getLanguageString('$STR_0142')}</h3>
                            <strong>{this.getLanguageString('$STR_0143')}, <br/>Francisco</strong>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div> 
        )
        if (this.state.activePage === "unterricht") {
            if (this.state.showLernvideos===false){
                content =  null               
            }            
            else{
                content = (
                    <Lernvideos
                        getString={this.getLanguageString}                    
                        produkt_lektionen={this.state.produkt_lektionen}
                        filtered_produkt_lektionen={this.state.filtered_produkt_lektionen}
                        produktSuchen={this.produktSuchen}
                        suchenText={this.state.suchenText}
                        setProduktSuchenText={(e)=>this.setState({suchenText:e.target.value}, ()=>this.produktSuchen())}
                        zeigeProdukt={this.zeigeProdukt}
                        gekauft={(produkt)=>this.gekauft(produkt)}
                        inDenEinkaufswagen={this.inDenEinkaufswagen}
                        clearSearch={()=>{this.setState({suchenText:''}, ()=>this.produktSuchen()) }}
                    />
                )
            }

        }

            

        
       
            
        return content;
    
    }

   
   

    render(){

        let btnShoppingCard = null
        if (this.state.einkaufswagen.length > 0){
            btnShoppingCard=(
                <div className="btn showin"  style={{
                    position:'fixed', 
                    right:'12px', 
                    top:'120px', 
                    zIndex:'5', 
                    textAlign:'center', 
                    color:'white', 
                    backgroundColor:'blueviolet',
                    paddingTop:'10px',
                    paddingBottom:'10px',
                    borderRadius:'12px',
                    cursor:'pointer',
                    }}
                    onClick={this.einkauf}>
                    {this.getLanguageString('$STR_0257')}&nbsp;&nbsp;<i className="material-icons">shopping_cart</i>&nbsp;&nbsp;{this.state.einkaufswagen.length}
                </div>
            )
        }

       
      
        let version = require("../../package.json").version

    
  

        return( 
             <CacheBuster
                currentVersion={version}
                isEnabled={true} //If false, the library is disabled.
                isVerboseMode={false} //If true, the library writes verbose logs to console.
                loadingComponent={<div>Check new version...</div>} //If not pass, nothing appears at the time of new version check.
            >
        
                  <div style={{width:'100%', overflowY:'auto', padding:'16px'}} className="showin">  
                        
                    {this.modalLogindialog()} {this.modalImpressum()} {this.modalDatenschutz()} {this.deleteSchuelerDialog()} {this.deleteAboDialog()} {this.modalEditLektion()}
                    {this.modalActiveSchuelerAboDialog()} {this.modalUnterrichtsAnfrageFertig()} {this.modalMessageBoxDialog()} {this.modalAngebotSchuelerAboDialog()}
                    {this.modalNeuerAkkordDialog()}{this.modalNeuesProduktDialog()} {this.modalNeueUnterrichtseinheit()} {this.modalDeleteUE()} {this.modalDeleteProdukt()}
                    {this.modalPdfDialog()} {this.anmeldeSubMenu()} {this.unterrichtsMenu()} {this.modalEinkaufswagen()}
     
                     

                   <Routes>
                        <Route  exact path='/' element={
                            <div >
                            {this.navBar()}                             
                            <div style={{marginTop:'55px', width:'100%', overflowX:'auto', position:'relative'}}>                          
                            {this.getContent()}</div>
                            {btnShoppingCard} 
                             {this.footer()}
                            </div>  
                            }
                            />  
                        
                            

                                                
                       
                        <Route exact path='concert' element = {
                            <div >
                            {this.navbar2()} 

                            {this.musicContent()}

                            <div className="col-12">
                                <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                    <div>
                                        <img className="card"  style={{width:'90%',margin:'auto', marginBottom:'25px'}} src="/assets/images/herbertgitarresw.png" />
                                    </div>                                
                                </div>
                                <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                    <div>
                                        <img className="card"  style={{width:'90%',margin:'auto', marginBottom:'25px'}} src="/assets/images/herbertmanolo.png" />
                                    </div>                                
                                </div>
                                <div className="slider-text  slider-text-two"  style={{boxShadow: '3px 2px #232124', width:'100%'}}>                                                
                                    <div>
                                        <img className="card"  style={{width:'90%',margin:'auto', marginBottom:'25px'}} src="/assets/images/juan-herbert-benahaviz_.png" />
                                    </div>                                
                                </div>
                            </div>

                            
                            </div>  
                        }/>
                    
                    

                    </Routes>
                    
                   
                   

                   
                
                </div>
            </CacheBuster>
       

        )
       

    }
}



export default Hauptseite;
